"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[52559,53360],{

/***/ 64465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ batch_useBatchDetails; },
  "k": function() { return /* binding */ getKey; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./src/hooks/useFetch.js
var useFetch = __webpack_require__(68826);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/api/processors/batch.js


/* eslint-disable import/prefer-default-export */ var processBatchDataFromAPI = function(batchDetails) {
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, batchDetails || {}), {
        testSeries: batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.testSeriesCount,
        authors: ((batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.authors) || []).map(function(author) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, author), {
                liveMinutes: author.liveMinutes ? Math.round(author.liveMinutes / 60) : 0,
                totalWatchMins: author.totalWatchTime ? Math.round(author.totalWatchTime / 60) : 0,
                name: "".concat(author.firstName || "", " ").concat(author.lastName || "")
            });
        })
    });
};

;// CONCATENATED MODULE: ./src/api/hooks/batch/useBatchDetails.js




var getKey = function(batchUID) {
    return "v2/batch/".concat(batchUID, "/details/");
};
var useBatchDetails = function(batchUID) {
    var key = getKey(batchUID);
    var _ref = (0,useFetch/* default */.Z)(batchUID ? key : null), batchDetails = _ref.data, rest = (0,_object_without_properties/* default */.Z)(_ref, [
        "data"
    ]);
    return (0,_object_spread/* default */.Z)({
        key: key,
        batchDetails: processBatchDataFromAPI(batchDetails)
    }, rest);
};
/* harmony default export */ var batch_useBatchDetails = (useBatchDetails);


/***/ }),

/***/ 19482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ PIP_ERROR_CODE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99534);
/* harmony import */ var _hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68826);
/* harmony import */ var _api_selectors_auth__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73060);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _auth_useMyInfo__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85780);






var PIP_ERROR_CODE = "E5222";
var usePartPaymentStatus = function(goalUID) {
    var isLoggedIn = (0,_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_3__/* .getIsLoggedIn */ .M7);
    var _ref = (0,_hooks_useFetch__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(goalUID && isLoggedIn ? "v1/subscriptions/pay_in_parts_subscription_details?goal_uid=".concat(goalUID) : null), data = _ref.data, error = _ref.isError, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_ref, [
        "data",
        "isError"
    ]);
    var partPaymentStatus = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (data) return data;
        if ((error === null || error === void 0 ? void 0 : error.error_code) === PIP_ERROR_CODE) return error;
        return null;
    }, [
        data,
        error
    ]);
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        partPaymentStatus: partPaymentStatus
    }, rest);
};
/* harmony default export */ __webpack_exports__["Z"] = (usePartPaymentStatus);


/***/ }),

/***/ 41327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ processCourse; }
/* harmony export */ });
/* unused harmony export getCourseAuthors */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _models_Course__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(56046);
/* harmony import */ var _user__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31079);




var getCourseAuthors = function(course) {
    var ref, ref1;
    if (course === null || course === void 0 ? void 0 : (ref = course.authors) === null || ref === void 0 ? void 0 : ref.length) return course === null || course === void 0 ? void 0 : (ref1 = course.authors) === null || ref1 === void 0 ? void 0 : ref1.map(function(author) {
        return (0,_user__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(author, false);
    });
    if (course === null || course === void 0 ? void 0 : course.author) return [
        (0,_user__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(course.author, false)
    ];
    return [];
};
var processCourse = function(course) {
    var ref, ref1, ref2, ref3;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, course), {
        authors: getCourseAuthors(course),
        liveAt: course.liveAt || course.startsAt,
        liveAtString: course.liveAt || course.startsAt,
        thumbnail: course.coverPhotoV1 || course.coverPhoto || course.thumbnail || (0,_models_Course__WEBPACK_IMPORTED_MODULE_0__/* .getDefaultThumbnail */ .mI)(course),
        coverPhoto: course.coverPhotoV1 || course.coverPhoto || course.thumbnail || (0,_models_Course__WEBPACK_IMPORTED_MODULE_0__/* .getDefaultThumbnail */ .mI)(course),
        newThumbnail: course.coverPhotoV1,
        language: course.languageDisplay || ((ref = course.multipleLanguageDisplay) === null || ref === void 0 ? void 0 : ref[0]),
        averageRating: course.avgRating,
        conceptTopology: ((ref1 = course.conceptTopology) === null || ref1 === void 0 ? void 0 : ref1.name) || ((ref2 = course.conceptTopology) === null || ref2 === void 0 ? void 0 : ref2.title) || ((ref3 = course.topologies) === null || ref3 === void 0 ? void 0 : ref3[0]) || "",
        isUpcoming: (0,_models_Course__WEBPACK_IMPORTED_MODULE_0__/* .isUpcoming */ .Zz)(course.startsAt),
        isOngoing: (0,_models_Course__WEBPACK_IMPORTED_MODULE_0__/* .isOngoing */ .fr)(course.startsAt, course.endsAt),
        isCompleted: course.isCompleted || (0,_models_Course__WEBPACK_IMPORTED_MODULE_0__/* .isCompleted */ .PN)(course.endsAt),
        nextTrack: course.nextTrack || course.nextSession || course.nextClass || course.nextItem,
        previousTrack: course.previousTrack || course.previousSession || course.previousClass || course.previousItem,
        courseType: course.programmeType,
        forPlus: course.forPlus || course.forSubscription
    });
};


/***/ }),

/***/ 18170:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BatchCardNew; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(95934);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(52420);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./src/components/Base/Thumbnail/Thumbnail.tsx
var Thumbnail = __webpack_require__(75591);
// EXTERNAL MODULE: ./src/components/Base/Link/Link.jsx
var Link = __webpack_require__(76356);
// EXTERNAL MODULE: ./src/components/Base/Divider/Divider.jsx
var Divider = __webpack_require__(46736);
// EXTERNAL MODULE: ./src/components/Base/H7/H7.jsx
var H7 = __webpack_require__(28197);
// EXTERNAL MODULE: ./src/components/Base/H6/H6.jsx
var H6 = __webpack_require__(10076);
// EXTERNAL MODULE: ./src/components/Icons/AddToList.jsx
var AddToList = __webpack_require__(91202);
// EXTERNAL MODULE: ./src/components/Icons/AddedToList.jsx
var AddedToList = __webpack_require__(12460);
// EXTERNAL MODULE: ./src/api/hooks/auth/useMyInfo.js
var useMyInfo = __webpack_require__(85780);
// EXTERNAL MODULE: ./src/api/selectors/auth.js
var auth = __webpack_require__(73060);
// EXTERNAL MODULE: ./src/components/Icons/Lock.jsx
var Lock = __webpack_require__(21589);
// EXTERNAL MODULE: ./src/components/Base/Image.jsx
var Image = __webpack_require__(80867);
// EXTERNAL MODULE: ./src/models/Batch.js
var Batch = __webpack_require__(47835);
// EXTERNAL MODULE: ./src/utils/textHelper.js
var textHelper = __webpack_require__(31309);
// EXTERNAL MODULE: ./src/hooks/useSubscribed.js
var useSubscribed = __webpack_require__(83497);
// EXTERNAL MODULE: ./src/styleConstants/index.js
var styleConstants = __webpack_require__(2080);
// EXTERNAL MODULE: ./src/components/Base/Tags/Tags.jsx
var Tags = __webpack_require__(52236);
// EXTERNAL MODULE: ./src/redux/actions/analytics.js
var analytics = __webpack_require__(87936);
// EXTERNAL MODULE: ./src/constants/index.js
var constants = __webpack_require__(43135);
// EXTERNAL MODULE: ./src/constants/segment.js
var segment = __webpack_require__(17579);
// EXTERNAL MODULE: ./src/hooks/useGoalEventProps.js
var useGoalEventProps = __webpack_require__(52405);
// EXTERNAL MODULE: ./src/hooks/useAllTypesOfCourseEventProps.js
var useAllTypesOfCourseEventProps = __webpack_require__(96780);
// EXTERNAL MODULE: ./src/hooks/useIsRecordedGoal.js
var useIsRecordedGoal = __webpack_require__(23207);
// EXTERNAL MODULE: ./src/components/Composite/CourseCard/index.js + 1 modules
var CourseCard = __webpack_require__(87414);
// EXTERNAL MODULE: ./src/components/Base/P1/P1.jsx
var P1 = __webpack_require__(85620);
// EXTERNAL MODULE: ./src/utils/dates.js
var dates = __webpack_require__(97428);
// EXTERNAL MODULE: ./src/components/Icons/EarlyMorning.jsx
var EarlyMorning = __webpack_require__(29327);
// EXTERNAL MODULE: ./src/components/Icons/Morning.jsx
var Morning = __webpack_require__(55951);
// EXTERNAL MODULE: ./src/components/Icons/Afternoon.jsx
var Afternoon = __webpack_require__(49250);
// EXTERNAL MODULE: ./src/components/Icons/Evening.jsx
var Evening = __webpack_require__(30693);
// EXTERNAL MODULE: ./src/components/Icons/LateEvening.jsx
var LateEvening = __webpack_require__(66741);
// EXTERNAL MODULE: ./src/components/Icons/Clock.jsx
var Clock = __webpack_require__(12656);
// EXTERNAL MODULE: ./src/components/Icons/CalendarSleek.jsx
var CalendarSleek = __webpack_require__(26845);
// EXTERNAL MODULE: ./src/components/Icons/EducatorAvatar.jsx
var EducatorAvatar = __webpack_require__(57586);
// EXTERNAL MODULE: ./src/redux/selectors/learner.js
var learner = __webpack_require__(11680);
// EXTERNAL MODULE: ./src/constants/empty.js
var empty = __webpack_require__(59375);
;// CONCATENATED MODULE: ./src/components/Composite/BatchCard/BatchCardInfo.jsx


















var classTimeIconMap = {
    1: EarlyMorning/* default */.Z,
    2: Morning/* default */.Z,
    3: Afternoon/* default */.Z,
    4: Evening/* default */.Z,
    5: LateEvening/* default */.Z,
    6: Clock/* default */.Z,
    7: Clock/* default */.Z,
    20: Clock/* default */.Z
};
var InfoRow = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1tlxngj0",
    label: "InfoRow"
})("display:flex;margin-bottom:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";:last-child{margin-bottom:0;}");
var IconWrap = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e1tlxngj1",
    label: "IconWrap"
})("margin-right:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";width:20px;height:20px;");
var StyledP1 = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(P1/* default */.Z, {
    target: "e1tlxngj2",
    label: "StyledP1"
})(styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{font-size:", styleConstants/* Fonts.P2 */.F3.P2, ";line-height:20px;}");
var oneDay = 24 * 60 * 60 * 1000;
var getDateInfo = function(startAt, endAt) {
    if (!startAt) return null;
    var start = new Date(startAt).setHours(0, 0, 0, 0);
    var end = endAt && new Date(endAt).setHours(0, 0, 0, 0);
    var current = new Date().setHours(0, 0, 0, 0);
    var startText = "".concat((0,dates/* getDay */.wf)(startAt), " ").concat((0,dates/* getMonthString */.dV)(startAt), " ").concat((0,dates/* getYear */.So)(startAt));
    var endText = endAt && "".concat((0,dates/* getDay */.wf)(endAt), " ").concat((0,dates/* getMonthString */.dV)(endAt), " ").concat((0,dates/* getYear */.So)(endAt));
    var dateInfo = "";
    if (start >= current) {
        var diff = Math.ceil((start - current) / oneDay);
        if (diff < 1) {
            dateInfo = "Starts today \xb7 ".concat(startText);
        } else if (diff < 2) {
            dateInfo = "Starts tomorrow \xb7 ".concat(startText);
        } else if (diff > 1 && diff < 8) {
            dateInfo = "Starts in ".concat(diff, " days \xb7 ").concat(startText);
        } else {
            dateInfo = "Starts on ".concat(startText);
        }
    } else if (start < current && (!end || current < end)) {
        dateInfo = "Started on ".concat(startText);
    } else {
        dateInfo = "Ended on ".concat(endText);
    }
    return dateInfo;
};
var BatchCardInfo = function(param) {
    var batch = param.batch, authors = param.authors, firstAuthorUsername = param.firstAuthorUsername;
    var startsAt = batch.startsAt, endsAt = batch.endsAt, timeType = batch.timeType;
    var batchAuthors = authors || batch.authors;
    var dateInfo = getDateInfo(startsAt, endsAt);
    var typeOfClassTime = timeType === null || timeType === void 0 ? void 0 : timeType.type;
    var ClassTimeType = typeOfClassTime && classTimeIconMap[typeOfClassTime];
    var firstUser = (0,es/* useSelector */.v9)((0,learner/* getUserById */.GA)(firstAuthorUsername));
    var authorsInfo = (0,react.useMemo)(function() {
        var firstUserName = firstUser === null || firstUser === void 0 ? void 0 : firstUser.name;
        var authorsNameArr = (batchAuthors === null || batchAuthors === void 0 ? void 0 : batchAuthors.map(function(author) {
            return author.name;
        })) || empty/* emptyList */.n8;
        if (firstUserName) {
            if (authorsNameArr.length) {
                var index = authorsNameArr.indexOf(firstUserName);
                authorsNameArr.splice(index, 1);
                authorsNameArr.splice(0, 0, firstUserName);
            } else {
                return firstUserName;
            }
        }
        if (authorsNameArr.length) {
            if (authorsNameArr.length < 2) {
                return authorsNameArr[0];
            }
            if (authorsNameArr.length > 1 && authorsNameArr.length < 4) {
                return "".concat(authorsNameArr.slice(0, -1).join(", "), " and ").concat(authorsNameArr.slice(-1));
            }
            return "".concat(authorsNameArr.slice(0, 3).join(", "), " and ").concat(authorsNameArr.length - 3, " more");
        }
    }, [
        batchAuthors,
        firstUser === null || firstUser === void 0 ? void 0 : firstUser.name
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            dateInfo && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InfoRow, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrap, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CalendarSleek/* default */.Z, {
                            size: "20px",
                            "aria-hidden": "true",
                            color: "var(--color-text-primary)"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledP1, {
                        "data-testid": "dateInfo",
                        children: dateInfo
                    })
                ]
            }),
            typeOfClassTime && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InfoRow, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrap, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ClassTimeType, {
                            size: "20px",
                            "aria-hidden": "true",
                            color: "var(--color-text-primary)"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledP1, {
                        children: timeType.text
                    })
                ]
            }),
            authorsInfo && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(InfoRow, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconWrap, {
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EducatorAvatar/* default */.Z, {
                            size: "20px",
                            "aria-hidden": "true",
                            color: "var(--color-text-primary)"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledP1, {
                        title: authorsInfo,
                        lineClamp: 2,
                        children: authorsInfo
                    })
                ]
            })
        ]
    });
};
BatchCardInfo.propTypes = {
    batch: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    firstAuthorUsername: (prop_types_default()).string
};
BatchCardInfo.defaultProps = {
    firstAuthorUsername: ""
};
/* harmony default export */ var BatchCard_BatchCardInfo = (BatchCardInfo);

// EXTERNAL MODULE: ./src/components/Composite/BatchCard/util.js
var util = __webpack_require__(5950);
;// CONCATENATED MODULE: ./src/components/Composite/BatchCard/BatchCardNew.jsx



/* eslint-disable no-param-reassign */ 




























var CourseThumbnail = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Thumbnail/* default */.Z, {
    target: "e4cynox0",
    label: "CourseThumbnail"
})("border-top-left-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";border-top-right-radius:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{width:100%;height:190px;}");
var CardContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(CourseCard/* Container */.W2, {
    target: "e4cynox1",
    label: "CardContainer"
})("position:relative;display:block;");
var Content = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e4cynox2",
    label: "Content"
})("overflow:hidden;padding:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";margin-bottom:", styleConstants/* Spacings.SPACING_14B */.t8.zJ, ";", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{margin-bottom:0;}");
var TagsWrap = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e4cynox3",
    label: "TagsWrap"
})();
var LanguageTag = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Tags/* default */.Z, {
    target: "e4cynox4",
    label: "LanguageTag"
})("width:fit-content;transition:all 300ms ease;margin-right:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";");
var BatchCompletionTag = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Tags/* default */.Z, {
    target: "e4cynox5",
    label: "BatchCompletionTag"
})("width:fit-content;transition:all 300ms ease;margin-right:", styleConstants/* Spacings.SPACING_2B */.t8.Rw, ";");
var CourseTitle = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(H6/* default */.Z, {
    target: "e4cynox6",
    label: "CourseTitle"
})("margin-top:", styleConstants/* Spacings.SPACING_3B */.t8.N, ";margin-bottom:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";color:var(--color-text-primary);font-size:", function(param) {
    var $isFeedCard = param.$isFeedCard;
    return $isFeedCard ? "18px" : "14px";
}, ";", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{font-size:16px;}");
var StyledDivider = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])(Divider/* default */.Z, {
    target: "e4cynox7",
    label: "StyledDivider"
})("margin:", styleConstants/* Spacings.SPACING_4B */.t8.BM, " auto;");
var TrialClassInfo = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e4cynox8",
    label: "TrialClassInfo"
})("display:flex;justify-content:center;align-items:flex-end;margin-bottom:", function(param) {
    var $isFeedCard = param.$isFeedCard;
    return $isFeedCard ? styleConstants/* Spacings.SPACING_2B */.t8.Rw : 0;
}, ";h6{margin-left:", styleConstants/* Spacings.SPACING_1B */.t8.MK, ";}");
var CardFooter = /*#__PURE__*/ (0,emotion_styled_browser_esm["default"])("div", {
    target: "e4cynox9",
    label: "CardFooter"
})("height:56px;position:absolute;bottom:", styleConstants/* Spacings.SPACING_4B */.t8.BM, ";width:100%;", styleConstants/* mediaQuery.uptoTablet */.cy.uptoTablet, "{position:relative;bottom:unset;}");
var trialClassIconMap = {
    1: "batch-live.svg",
    2: "batch-play.svg",
    3: "batch-play-all.svg"
};
var BatchCard = function(param) {
    var gridColumn = param.gridColumn, className = param.className, batch = param.batch, toggleEnroll = param.toggleEnroll, orientation = param.orientation, firstAuthorUsername = param.firstAuthorUsername, dataAnalytics = param.dataAnalytics, index = param.index, type = param.type, updateRecentSearchLog = param.updateRecentSearchLog, searchData = param.searchData, hideEnroll = param.hideEnroll, isFeedCard = param.isFeedCard, onClick = param.onClick;
    var ref, ref1;
    var dispatch = (0,es/* useDispatch */.I0)();
    var batchGoalUID = (batch === null || batch === void 0 ? void 0 : (ref = batch.goal) === null || ref === void 0 ? void 0 : ref.uid) || "";
    var meUID = (0,useMyInfo/* default */.Z)(auth/* getMeUid */.Up);
    var languages = batch.languages, name = batch.name, trialClasses = batch.trialClasses;
    var authors = (ref1 = batch.authors) === null || ref1 === void 0 ? void 0 : ref1.map(function(author) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, author), {
            name: author.name || "".concat(author.firstName, " ").concat(author.lastName)
        });
    });
    var isSubscribed = (0,useSubscribed/* default */.Z)(batchGoalUID);
    var goalSegmentData = (0,useGoalEventProps/* default */.Z)({
        batchGoalUID: batchGoalUID
    });
    var segmentData = (0,useAllTypesOfCourseEventProps/* default */.Z)({
        course: batch,
        isBatch: true
    });
    var isEnrolledFromStore = (0,es/* useSelector */.v9)(function(state) {
        var ref;
        return (batch === null || batch === void 0 ? void 0 : batch.uid) && ((ref = state.batches.data[batch === null || batch === void 0 ? void 0 : batch.uid]) === null || ref === void 0 ? void 0 : ref.isEnrolled);
    });
    var isEnrolledInBatch = (isEnrolledFromStore !== null && isEnrolledFromStore !== void 0 ? isEnrolledFromStore : batch.isEnrolled) || false;
    var isRecordedGoal = (0,useIsRecordedGoal/* default */.Z)(batchGoalUID);
    var renderIconButton = (0,react.useMemo)(function() {
        var EnrollButtonIcon = null;
        if (!isSubscribed) {
            EnrollButtonIcon = Lock/* default */.Z;
        } else if (isEnrolledInBatch) {
            EnrollButtonIcon = AddedToList/* default */.Z;
        } else {
            EnrollButtonIcon = AddToList/* default */.Z;
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(EnrollButtonIcon, {
            size: styleConstants/* Spacings.SPACING_5B */.t8.zj
        });
    }, [
        isEnrolledInBatch,
        isSubscribed
    ]);
    if (!batch) return null;
    var handleEnroll = function(e) {
        e.stopPropagation();
        e.preventDefault();
        toggleEnroll(batch.uid, isEnrolledInBatch, batch, (0,_object_spread/* default */.Z)({}, goalSegmentData, segmentData), isRecordedGoal);
    };
    var handleAnalytics = function() {
        if (onClick) onClick();
        var batchUID = batch.uid || "";
        if (type === "search") {
            var nSearchData = (0,_object_spread/* default */.Z)({}, searchData);
            delete nSearchData.query;
            var position = nSearchData.position ? nSearchData.position : "See all";
            analytics/* segment.track */.EX.track(segment/* SEARCH_RESULT_CLICKED */.dW7, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, goalSegmentData, nSearchData), {
                sub_position: index + 1,
                educator_uid: (0,textHelper/* getCommaSeparatedUIDs */.$V)(authors),
                educator_username: (0,textHelper/* getCommaSeparatedUIDs */.$V)(authors, "username"),
                educator_name: (0,textHelper/* getCommaSeparatedUIDs */.$V)(authors, "name"),
                last_primary_source: segment/* SEARCH_RESULT_PAGE */.jDH,
                last_primary_source_section: "Batches",
                search_section: "Global",
                current_screen: "Batches",
                eventName: segment/* SEARCH_RESULT_CLICKED */.dW7,
                eventType: "click",
                version: 2,
                objectID: "".concat(searchData.object_type, ":").concat(batchUID),
                userToken: meUID
            }), nSearchData), {
                position: position
            }), constants/* evtNameCategoryMap.WITHOUT_CATEGORY */.xK.WITHOUT_CATEGORY);
            dispatch(updateRecentSearchLog((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, searchData), {
                entity_id: "".concat(searchData.object_type, ":").concat(batchUID),
                goal_uid: batchGoalUID
            })));
        }
    };
    var renderLanguages = function() {
        var languagesToShow = (languages === null || languages === void 0 ? void 0 : languages.length) > 3 ? languages.slice(0, 3) : languages;
        return languagesToShow === null || languagesToShow === void 0 ? void 0 : languagesToShow.map(function(language) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LanguageTag, {
                type: "hollow",
                children: language.label
            }, language.label);
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContainer, {
        className: className,
        gridColumn: gridColumn,
        orientation: orientation,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Link/* default */.Z, {
            href: (0,Batch/* getLinkPath */.bc)(),
            as: (0,Batch/* getLink */.Rg)(batch),
            onClick: handleAnalytics,
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseThumbnail, {
                    imgUrl: batch.thumbnail || batch.coverPhoto,
                    orientation: orientation,
                    "data-analytics": "".concat(dataAnalytics, "Card")
                }),
                !hideEnroll && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseCard/* EnrollButton */.a0, {
                    dropShadow: true,
                    onClick: isSubscribed ? handleEnroll : undefined,
                    iconProps: {
                        hovDisabled: true
                    },
                    isEnrolled: isEnrolledInBatch,
                    disableHover: !isSubscribed,
                    dataAnalytics: "".concat(dataAnalytics, "-courseEnroll"),
                    children: renderIconButton
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Content, {
                    $isFeedCard: isFeedCard,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TagsWrap, {
                            children: [
                                languages && renderLanguages(),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BatchCompletionTag, {
                                    type: "hollow",
                                    children: (0,util/* getBatchTag */.vi)(batch)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CourseTitle, {
                            lineClamp: 2,
                            as: "h4",
                            $isFeedCard: isFeedCard,
                            children: name
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BatchCard_BatchCardInfo, {
                            batch: batch,
                            authors: authors,
                            firstAuthorUsername: firstAuthorUsername
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(CardFooter, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDivider, {}),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(TrialClassInfo, {
                            $isFeedCard: isFeedCard,
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image["default"], {
                                    src: trialClassIconMap[trialClasses === null || trialClasses === void 0 ? void 0 : trialClasses.type] || "batch-play-all.svg",
                                    alt: "play",
                                    width: 16,
                                    height: 16
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(H7/* default */.Z, {
                                    color: (trialClasses === null || trialClasses === void 0 ? void 0 : trialClasses.type) === 1 ? "var(--color-i-red)" : "var(--color-text-primary)",
                                    children: (trialClasses === null || trialClasses === void 0 ? void 0 : trialClasses.text) || "View full schedule"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ var BatchCardNew = (BatchCard);
BatchCard.propTypes = {
    gridColumn: (prop_types_default()).string,
    className: (prop_types_default()).string,
    firstAuthorUsername: (prop_types_default()).string,
    orientation: prop_types_default().oneOf([
        "horizontal",
        "vertical"
    ]),
    batch: prop_types_default().objectOf((prop_types_default()).any).isRequired,
    toggleEnroll: (prop_types_default()).func.isRequired,
    dataAnalytics: (prop_types_default()).string,
    index: (prop_types_default()).number.isRequired,
    type: (prop_types_default()).string,
    updateRecentSearchLog: (prop_types_default()).func,
    searchData: prop_types_default().objectOf((prop_types_default()).any),
    hideEnroll: (prop_types_default()).bool,
    isFeedCard: (prop_types_default()).bool,
    isEnrolled: (prop_types_default()).bool
};
BatchCard.defaultProps = {
    gridColumn: "span 6",
    className: "",
    orientation: "vertical",
    firstAuthorUsername: "",
    dataAnalytics: "",
    type: "",
    updateRecentSearchLog: function() {},
    searchData: {},
    hideEnroll: false,
    isFeedCard: false,
    isEnrolled: false
};


/***/ }),

/***/ 5950:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZW": function() { return /* binding */ authorsInfo; },
/* harmony export */   "on": function() { return /* binding */ getDateInfo; },
/* harmony export */   "vi": function() { return /* binding */ getBatchTag; }
/* harmony export */ });
/* harmony import */ var _constants_empty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59375);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97428);


var oneDay = 24 * 60 * 60 * 1000;
var getBatchTag = function() {
    var batch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var syllabusTag = batch.syllabusTag, allTopicsCovered = batch.allTopicsCovered;
    var tag = allTopicsCovered ? "Full syllabus" : "Partial Syllabus";
    return syllabusTag || tag;
};
var getDateInfo = function(startAt, endAt) {
    if (!startAt) return null;
    var start = new Date(startAt).setHours(0, 0, 0, 0);
    var end = endAt && new Date(endAt).setHours(0, 0, 0, 0);
    var current = new Date().setHours(0, 0, 0, 0);
    var startText = "".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .getDay */ .wf)(startAt), " ").concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .getMonthString */ .dV)(startAt), " ").concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .getYear */ .So)(startAt));
    var endText = endAt && "".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .getDay */ .wf)(endAt), " ").concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .getMonthString */ .dV)(endAt), " ").concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .getYear */ .So)(endAt));
    var dateInfo = "";
    if (start >= current) {
        var diff = Math.ceil((start - current) / oneDay);
        if (diff < 1) {
            dateInfo = "Starts today \xb7 ".concat(startText);
        } else if (diff < 2) {
            dateInfo = "Starts tomorrow \xb7 ".concat(startText);
        } else if (diff > 1 && diff < 8) {
            dateInfo = "Starts in ".concat(diff, " days \xb7 ").concat(startText);
        } else {
            dateInfo = "Starts on ".concat(startText);
        }
    } else if (start < current && (!end || current < end)) {
        dateInfo = "Started on ".concat(startText);
    } else {
        dateInfo = "Ended on ".concat(endText);
    }
    return dateInfo;
};
var authorsInfo = function(firstUser, batchAuthors) {
    var firstUserName = firstUser === null || firstUser === void 0 ? void 0 : firstUser.name;
    var authorsNameArr = (batchAuthors === null || batchAuthors === void 0 ? void 0 : batchAuthors.map(function(author) {
        return author.name;
    })) || _constants_empty__WEBPACK_IMPORTED_MODULE_0__/* .emptyList */ .n8;
    if (firstUserName) {
        if (authorsNameArr.length) {
            var index = authorsNameArr.indexOf(firstUserName);
            authorsNameArr.splice(index, 1);
            authorsNameArr.splice(0, 0, firstUserName);
        } else {
            return firstUserName;
        }
    }
    if (authorsNameArr.length) {
        if (authorsNameArr.length < 2) {
            return authorsNameArr[0];
        }
        if (authorsNameArr.length > 1 && authorsNameArr.length < 4) {
            return "".concat(authorsNameArr.slice(0, -1).join(", "), " and ").concat(authorsNameArr.slice(-1));
        }
        return "".concat(authorsNameArr.slice(0, 3).join(", "), " and ").concat(authorsNameArr.length - 3, " more");
    }
    return "";
};


/***/ }),

/***/ 81879:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _base_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(42531);
/* harmony import */ var _base_H4_H4__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64250);
/* harmony import */ var _base_Grow_Grow__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5010);
/* harmony import */ var _base_Link_Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76356);
/* harmony import */ var _base_P1_P1__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(85620);
/* harmony import */ var _icon_ChevronLeft__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(19927);
/* harmony import */ var _icon_ChevronRight__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(91656);
/* harmony import */ var _utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87312);
/* harmony import */ var _base_Button_Button__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35415);
/* harmony import */ var _hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50420);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2080);
/* harmony import */ var _utils_pushRoute__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(751);
/* harmony import */ var aquilla_core_atoms_Typography__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(82353);

/* eslint-disable react/no-array-index-key */ 















var StyH4 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_H4_H4__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "ejsopzy0",
    label: "StyH4"
})("color:var(--color-text-primary);");
var BoldP1 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_P1_P1__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    target: "ejsopzy1",
    label: "BoldP1"
})("font-weight:", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Fonts.BOLD */ .F3.Pl, ";");
var ItemWrap = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "ejsopzy2",
    label: "ItemWrap"
})("grid-column:", function(param) {
    var gridColumn = param.gridColumn;
    return gridColumn;
}, ";opacity:", function(param) {
    var opacity = param.opacity;
    return opacity;
}, ";display:flex;transition:opacity 1000ms ease-in,transform 400ms ease-in !important;", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{opacity:1;grid-row:1;grid-column:span 1;}");
var CarouselWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "ejsopzy3",
    label: "CarouselWrapper"
})("grid-column:", function(param) {
    var gridColumn = param.gridColumn;
    return gridColumn;
}, ";position:relative;width:calc(100% + ", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_8B */ .t8.B3, ");margin-left:-", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_4B */ .t8.BM, ";margin-right:-", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_4B */ .t8.BM, ";", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{margin-left:0;margin-right:0px;width:100%;", function(param) {
    var $css = param.$css;
    return $css;
}, " ", function(param) {
    var $hasSeeAll = param.$hasSeeAll;
    return $hasSeeAll ? "margin-bottom:0;" : "";
}, "}");
var CardContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "ejsopzy4",
    label: "CardContainer"
})("display:grid;grid-template-columns:", function(param) {
    var $gridTemplateColumns = param.$gridTemplateColumns;
    return "repeat(".concat($gridTemplateColumns, ", 32px)");
}, ";grid-column-gap:", function(param) {
    var $gridColumnGap = param.$gridColumnGap;
    return $gridColumnGap || _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_4B */ .t8.BM;
}, ";overflow:hidden;padding-left:", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_4B */ .t8.BM, ";padding-bottom:", function(param) {
    var $showBottomGap = param.$showBottomGap;
    return $showBottomGap ? _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_9B */ .t8.No : "0px";
}, ";& > a,& > div{transform:", function(param) {
    var pos = param.pos;
    return pos && "translate3d(calc(".concat(-100 * pos, "% - ").concat(pos * 16, "px), 0, 0)") || "initial";
}, ";transition:transform 400ms ease-in;}", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{padding:0 ", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_4B */ .t8.BM, " ", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_6B */ .t8.BY, " ", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_4B */ .t8.BM, ";margin:0 -16px;overflow:scroll;overscroll-behavior:unset;scroll-behavior:smooth;grid-template-columns:", function(param) {
    var $numberOfItemsToShow = param.$numberOfItemsToShow, $nItems = param.$nItems;
    return "repeat(\n      ".concat($nItems, ",\n      minmax(").concat($numberOfItemsToShow === 1 ? "100%" : "250px", ", 1fr)\n    )");
}, ";::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;}");
var ControlButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "ejsopzy5",
    label: "ControlButton"
})("position:absolute;right:", function(param) {
    var $isUnIconArrow = param.$isUnIconArrow;
    return $isUnIconArrow && "-16px";
}, " !important;", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .mediaQuery.uptoIconTablet */ .cy.uptoIconTablet, "{right:", function(param) {
    var $isUnIconArrow = param.$isUnIconArrow;
    return $isUnIconArrow && "0px";
}, ";}/* turning off for now as suggested by design */\n  /* visibility:hidden;*/\n  /* opacity:0;*/\n  transition:visibility 0s linear 300ms,opacity 300ms;top:calc(50% - 16px - ", function(param) {
    var $topAdjustment = param.$topAdjustment;
    return $topAdjustment;
}, ");box-shadow:", (0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(), ";/* turning off for now as suggested by design */\n  /* ", CarouselWrapper, ":hover &{visibility:visible;opacity:1;transition:visibility 0s linear 0s,opacity 300ms;}*/\n  ", function(param) {
    var direction = param.direction;
    return direction === "prev" ? "left" : "right";
}, ":0px;", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{display:none;}");
var CaraouselInfo = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "ejsopzy6",
    label: "CaraouselInfo"
})("display:flex;margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_4B */ .t8.BM, ";margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_7B */ .t8.d5, ";align-items:center;padding:0;grid-column:span 18;@media (max-width:70.95em){margin:0 0 24px;}");
var NavButtonsContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "ejsopzy7",
    label: "NavButtonsContainer"
})("grid-column:", function(param) {
    var $gridColumn = param.$gridColumn;
    return $gridColumn;
}, ";padding:", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_2B */ .t8.Rw, ";padding-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_2B */ .t8.Rw, ";display:flex;justify-content:center;margin-top:0px;");
var NavButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "ejsopzy8",
    label: "NavButton"
})("width:", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_2B */ .t8.Rw, ";height:", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_2B */ .t8.Rw, ";border-radius:50%;background-color:", function(param) {
    var $isSelected = param.$isSelected;
    return $isSelected ? "var(--color-text-secondary)" : "var(--color-divider)";
}, ";margin:0 ", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_1B */ .t8.MK, ";cursor:pointer;");
var SeeAll = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_Button_Button__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
    target: "ejsopzy9",
    label: "SeeAll"
})("display:none;", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{display:block;min-height:40px;height:40px;width:100%;background:var(--color-i-white);border:1px solid var(--color-divider);border-radius:8px;color:var(--color-i-green);font-size:14px;margin:16px 0 56px;}");
var InfoSectionsDiv = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "ejsopzy10",
    label: "InfoSectionsDiv"
})();
var Description = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(aquilla_core_atoms_Typography__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
    target: "ejsopzy11",
    label: "Description"
})("color:var(--color-text-secondary);margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_1B */ .t8.MK, ";");
var Carousel = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(param, ref) {
    var children = param.children, label = param.label, seeAllLink = param.seeAllLink, href = param.href, showControls = param.showControls, className = param.className, numberOfItems = param.numberOfItems, minItems = param.minItems, gridColumn = param.gridColumn, itemGridColumn = param.itemGridColumn, gridColumnGap = param.gridColumnGap, showNavButtons = param.showNavButtons, showLabel = param.showLabel, viewRef = param.viewRef, showInfo = param.showInfo, showBottomGap = param.showBottomGap, $css = param.$css, autoScroll = param.autoScroll, autoScrollDelay = param.autoScrollDelay, handleClickSeeAll = param.handleClickSeeAll, labelChild = param.labelChild, isUnIconArrow = param.isUnIconArrow, gridTemplateColumns = param.gridTemplateColumns, description = param.description;
    var cardContainerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var isMobile = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)().isMobile;
    var items = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(children);
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), pos = _$ref[0], setPos = _$ref[1];
    var showNavigationButtons = showNavButtons && items.length > 1;
    var finalItems = items.map(function(item, index) {
        var gridColumnForItem = itemGridColumn || item.props.gridColumn || "span 6";
        var endPoint = pos + (numberOfItems - 1);
        var startPoint = pos;
        var opacity = index >= startPoint && index <= endPoint ? 1 : 0;
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ItemWrap, {
            gridColumn: gridColumnForItem,
            opacity: opacity,
            children: item
        }, index);
    });
    var handleNext = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (items.length - numberOfItems - 1 >= pos - minItems) setPos(pos + 1);
    }, [
        items.length,
        numberOfItems,
        minItems,
        pos
    ]);
    var handlePrev = function() {
        if (pos > 0) setPos(pos - 1);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var timer = null;
        if (autoScroll) {
            timer = setInterval(function() {
                if (items.length - numberOfItems - 1 >= pos) {
                    handleNext();
                } else {
                    setPos(0);
                }
            }, autoScrollDelay);
        }
        return function() {
            clearInterval(timer);
        };
    }, [
        autoScroll,
        autoScrollDelay,
        handleNext,
        items,
        numberOfItems,
        pos
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // Reset position to 0 on resizing between screen sizes to avoid the disappearing carousel problem.
        setPos(0);
        if (cardContainerRef.current) cardContainerRef.current.scrollLeft = 0;
    }, [
        isMobile
    ]);
    var controlButtons = function() {
        if (!showControls || items.length <= numberOfItems - minItems) return null;
        var prevAvailable = pos > 0;
        var nextAvailable = pos - minItems < items.length - numberOfItems;
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .Fragment */ .HY, {
            children: [
                prevAvailable ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ControlButton, {
                    onClick: handlePrev,
                    direction: "prev",
                    bgColor: isUnIconArrow ? "var(--color-i-icon-dark)" : "var(--color-base-1)",
                    hovDisabled: true,
                    $topAdjustment: showNavigationButtons ? "18px" : "0px",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_icon_ChevronLeft__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        size: "24px",
                        "aria-hidden": "true",
                        color: isUnIconArrow ? "var(--color-i-icon-light-tertiary)" : "var(--color-text-primary)"
                    })
                }) : null,
                nextAvailable ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ControlButton, {
                    onClick: handleNext,
                    direction: "next",
                    bgColor: isUnIconArrow ? "var(--color-i-icon-dark)" : "var(--color-base-1)",
                    hovDisabled: true,
                    $isUnIconArrow: isUnIconArrow,
                    $topAdjustment: showNavigationButtons ? "18px" : "0px",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_icon_ChevronRight__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                        size: "24px",
                        "aria-hidden": "true",
                        color: isUnIconArrow ? "var(--color-i-icon-light-tertiary)" : "var(--color-text-primary)"
                    })
                }) : null
            ]
        });
    };
    var renderNavButtons = function() {
        var handlenavButtonClick = function(position) {
            return function() {
                setPos(position);
            };
        };
        if (showNavigationButtons) {
            var navbuttons = items.map(function(_, index) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(NavButton, {
                    onClick: handlenavButtonClick(index),
                    $isSelected: index === pos
                }, index);
            });
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(NavButtonsContainer, {
                $gridColumn: gridColumn,
                children: navbuttons
            });
        }
        return null;
    };
    var seeAllAnalytics = function() {
        if (handleClickSeeAll) {
            handleClickSeeAll();
        }
    };
    var onClickSeeAll = function() {
        (0,_utils_pushRoute__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(href, seeAllLink);
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .Fragment */ .HY, {
        children: [
            showInfo && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(CaraouselInfo, {
                ref: ref,
                className: className,
                children: [
                    showLabel && items.length > 0 && labelChild ? labelChild : null,
                    showLabel && items.length > 0 && !labelChild && label ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(InfoSectionsDiv, {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(StyH4, {
                                as: "h2",
                                children: label
                            }),
                            description && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(Description, {
                                variant: "p2",
                                children: description
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_base_Grow_Grow__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {}),
                    seeAllLink && !isMobile && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_base_Link_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        as: seeAllLink,
                        href: href,
                        onClick: seeAllAnalytics,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(BoldP1, {
                            color: "var(--color-i-green)",
                            children: "SEE ALL"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(CarouselWrapper, {
                gridColumn: gridColumn,
                ref: viewRef,
                $css: $css,
                $hasSeeAll: seeAllLink && isMobile,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(CardContainer, {
                        $gridColumnGap: gridColumnGap,
                        $showBottomGap: showBottomGap,
                        $gridTemplateColumns: gridTemplateColumns,
                        pos: pos,
                        $numberOfItemsToShow: numberOfItems,
                        $nItems: finalItems.length,
                        ref: cardContainerRef,
                        children: finalItems
                    }),
                    controlButtons()
                ]
            }),
            renderNavButtons(),
            !seeAllLink ? null : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(SeeAll, {
                label: "See All",
                onClick: onClickSeeAll
            })
        ]
    });
});
Carousel.displayName = "Carousel";
Carousel.propTypes = {
    showInfo: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().bool),
    showBottomGap: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().bool),
    children: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().node.isRequired),
    label: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string),
    seeAllLink: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string),
    href: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string),
    showControls: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().bool),
    numberOfItems: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().number),
    minItems: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().number),
    gridColumn: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string),
    itemGridColumn: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string),
    gridColumnGap: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string),
    showNavButtons: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().bool),
    gridTemplateColumns: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().number),
    showLabel: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().bool),
    viewRef: prop_types__WEBPACK_IMPORTED_MODULE_16___default().shape({
        current: prop_types__WEBPACK_IMPORTED_MODULE_16___default().oneOfType([
            (prop_types__WEBPACK_IMPORTED_MODULE_16___default().any)
        ])
    }),
    $css: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string),
    autoScroll: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().bool),
    autoScrollDelay: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().number),
    handleClickSeeAll: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().func),
    isUnIconArrow: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().bool),
    description: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string)
};
Carousel.defaultProps = {
    showInfo: true,
    gridTemplateColumns: 600,
    showBottomGap: true,
    label: null,
    seeAllLink: null,
    href: null,
    showControls: true,
    numberOfItems: 3,
    minItems: 0,
    gridColumn: "span 18",
    itemGridColumn: null,
    gridColumnGap: null,
    className: "",
    showNavButtons: false,
    showLabel: true,
    viewRef: null,
    $css: "",
    autoScroll: false,
    autoScrollDelay: 5000,
    handleClickSeeAll: function() {},
    isUnIconArrow: false,
    description: ""
};
/* harmony default export */ __webpack_exports__["default"] = (Carousel);


/***/ }),

/***/ 53360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_35__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _base_Thumbnail_Thumbnail__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75591);
/* harmony import */ var _base_Link_Link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(76356);
/* harmony import */ var _base_LinearProgressBar_LinearProgressBar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(50699);
/* harmony import */ var _base_Tags_Tags__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52236);
/* harmony import */ var _icon_AddToList__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91202);
/* harmony import */ var _icon_AddedToList__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12460);
/* harmony import */ var _icon_Lock__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(21589);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(97428);
/* harmony import */ var _models_Course__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(56046);
/* harmony import */ var _hooks_useSubscribed__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(83497);
/* harmony import */ var _events_segmentStorage__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(71250);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _actions_analytics__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(87936);
/* harmony import */ var _hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(52405);
/* harmony import */ var _hooks_useAllTypesOfCourseEventProps__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(96780);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(2080);
/* harmony import */ var _api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(85780);
/* harmony import */ var _api_selectors_auth__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(73060);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(31309);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(43135);
/* harmony import */ var _constants_segment__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(17579);
/* harmony import */ var _cont_Syllabus_constants_getTopicGroupAssetObj__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(77608);
/* harmony import */ var _utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(87312);
/* harmony import */ var _hooks_useIsRecordedGoal__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(23207);
/* harmony import */ var _api_selectors_subscription__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(58063);
/* harmony import */ var _api_fetchers_search_search__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(83606);
/* harmony import */ var _CourseCard__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(87414);
/* harmony import */ var _PlusCourseCardDetails__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(26391);
/* harmony import */ var _placeholderCourseThumbail_CoursePlaceholder__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(7125);
/* harmony import */ var _placeholderCourseThumbail_SvgThumbnail__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(95597);




































var SvgCourseThumbnail = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_placeholderCourseThumbail_SvgThumbnail__WEBPACK_IMPORTED_MODULE_30__/* ["default"] */ .Z, {
    target: "e3nlqzr0",
    label: "SvgCourseThumbnail"
})("width:272px;height:", function(param) {
    var $orientation = param.$orientation;
    return $orientation === "horizontal" ? "152px" : "auto";
}, ";", _styles_index__WEBPACK_IMPORTED_MODULE_17__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{width:100%;border-radius:0;}");
var CourseThumbnail = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_Thumbnail_Thumbnail__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "e3nlqzr1",
    label: "CourseThumbnail"
})("width:272px;height:", function(param) {
    var orientation = param.orientation;
    return orientation === "horizontal" && "152px";
}, ";", _styles_index__WEBPACK_IMPORTED_MODULE_17__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{width:100%;border-radius:0;}");
var CardContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_CourseCard__WEBPACK_IMPORTED_MODULE_27__/* .Container */ .W2, {
    target: "e3nlqzr2",
    label: "CardContainer"
})("display:flex;flex:1;overflow:hidden;height:100%;flex-direction:", function(param) {
    var orientation = param.orientation;
    return orientation === "horizontal" ? "row" : "column";
}, ";@media only screen and (max-width:47.95em){flex:auto;box-shadow:", (0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({
    blur: _styles_index__WEBPACK_IMPORTED_MODULE_17__/* .Spacings.SPACING_4B */ .t8.BM
}), ";}");
var PlaceholderThumbnail = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_placeholderCourseThumbail_CoursePlaceholder__WEBPACK_IMPORTED_MODULE_29__/* ["default"] */ .Z, {
    target: "e3nlqzr3",
    label: "PlaceholderThumbnail"
})("height:100%;width:100%;transform:scale(1.02);background-color:var(--color-divider);object-fit:cover;@media only screen and (max-width:47.95em){transform:scale(1);}");
var DefaultThumbnail = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e3nlqzr4",
    label: "DefaultThumbnail"
})("position:relative;overflow:hidden;border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_17__/* .Spacings.SPACING_2B */ .t8.Rw, ";");
var ProgressTag = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_Tags_Tags__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    target: "e3nlqzr5",
    label: "ProgressTag"
})("background-color:var(--color-i-black);color:var(--color-i-white);margin-right:", _styles_index__WEBPACK_IMPORTED_MODULE_17__/* .Spacings.SPACING_2B */ .t8.Rw, ";");
var Tag = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_CourseCard__WEBPACK_IMPORTED_MODULE_27__/* .StyledTag */ .w5, {
    target: "e3nlqzr6",
    label: "Tag"
})("position:static;");
var StyledProgressbar = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_LinearProgressBar_LinearProgressBar__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    target: "e3nlqzr7",
    label: "StyledProgressbar"
})("&.MuiLinearProgress-root{height:", _styles_index__WEBPACK_IMPORTED_MODULE_17__/* .Spacings.SPACING_6 */ .t8.A1, ";border-radius:", _styles_index__WEBPACK_IMPORTED_MODULE_17__/* .Spacings.SPACING_2B */ .t8.Rw, ";border-top-left-radius:0;}");
var CourseProgressbar = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(StyledProgressbar, {
    target: "e3nlqzr8",
    label: "CourseProgressbar"
})("position:absolute;left:0px;bottom:0px;");
var TagsWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "e3nlqzr9",
    label: "TagsWrapper"
})("position:absolute;left:", _styles_index__WEBPACK_IMPORTED_MODULE_17__/* .Spacings.SPACING_4B */ .t8.BM, ";bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_17__/* .Spacings.SPACING_14 */ .t8.Be, ";");
var getTopicName = function(topicGroups, topic) {
    var ref, ref1;
    var topicName = (topicGroups === null || topicGroups === void 0 ? void 0 : (ref = topicGroups[0]) === null || ref === void 0 ? void 0 : ref.name) || (topicGroups === null || topicGroups === void 0 ? void 0 : (ref1 = topicGroups[0]) === null || ref1 === void 0 ? void 0 : ref1.title) || "";
    if (topic && topic.uid) {
        topicName = topic.name;
    }
    return topicName;
};
var PlusCourseCard = function(param) {
    var gridColumn = param.gridColumn, orientation = param.orientation, className = param.className, course = param.course, toggleEnroll = param.toggleEnroll, cardType = param.cardType, topic = param.topic, type = param.type, imageBorderRadius = param.imageBorderRadius, showProgress = param.showProgress, dataAnalytics = param.dataAnalytics, index = param.index, label = param.label, lastPrimarySource = param.lastPrimarySource, searchData = param.searchData, disabledTopicGroup = param.disabledTopicGroup, hideLessonCount = param.hideLessonCount, onCardClick = param.onCardClick;
    var ref;
    var authors = course.authors;
    var isTestSeries = course.courseType === _constants_index__WEBPACK_IMPORTED_MODULE_20__/* .programmeTypes.TESTSERIES */ .h7.TESTSERIES;
    var goalUID = (course === null || course === void 0 ? void 0 : course.goalUid) || (course === null || course === void 0 ? void 0 : (ref = course.goal) === null || ref === void 0 ? void 0 : ref.uid);
    var pathname = (0,next_router__WEBPACK_IMPORTED_MODULE_13__.useRouter)().pathname;
    var isSubscribed = (0,_hooks_useSubscribed__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(goalUID);
    var isSubscribedToLite = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)((0,_api_selectors_subscription__WEBPACK_IMPORTED_MODULE_25__/* .getIsSubscribedToLite */ .aA)(goalUID));
    var isEnrolledInCourse = course.isEnrolled || false;
    var isTestSeriesAndEnrolledPage = pathname.includes("enrolled") && isTestSeries && !course.isPartOfBatch;
    var isLoggedIn = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_31__/* .getIsLoggedIn */ .M7);
    var goalSegmentData = (0,_hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)({
        goalUID: goalUID
    });
    var segmentData = (0,_hooks_useAllTypesOfCourseEventProps__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)({
        course: course
    });
    var topicGroups = course.topicGroups;
    var topicName = getTopicName(topicGroups, topic);
    var color = (0,_cont_Syllabus_constants_getTopicGroupAssetObj__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)(topicName).color;
    var meUID = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_31__/* .getMeUid */ .Up);
    var coverPhoto = course.coverPhotoV1 || course.coverPhoto || course.thumbnail || (0,_models_Course__WEBPACK_IMPORTED_MODULE_10__/* .getDefaultThumbnail */ .mI)(course);
    var isRecordedGoal = (0,_hooks_useIsRecordedGoal__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)(goalUID);
    var renderIconButton = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var EnrollButtonIcon = null;
        if (isSubscribedToLite) {
            if (isTestSeriesAndEnrolledPage && isEnrolledInCourse) {
                EnrollButtonIcon = _icon_AddedToList__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z;
            } else if (!isEnrolledInCourse && isTestSeriesAndEnrolledPage) {
                EnrollButtonIcon = _icon_AddToList__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
            } else {
                EnrollButtonIcon = _icon_Lock__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z;
            }
        } else if (!isSubscribed) {
            EnrollButtonIcon = _icon_Lock__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z;
        } else if (isEnrolledInCourse) {
            EnrollButtonIcon = _icon_AddedToList__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z;
        } else {
            EnrollButtonIcon = _icon_AddToList__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z;
        }
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsx */ .tZ)(EnrollButtonIcon, {
            size: _styles_index__WEBPACK_IMPORTED_MODULE_17__/* .Spacings.SPACING_5B */ .t8.zj
        });
    }, [
        isEnrolledInCourse,
        isSubscribed,
        isSubscribedToLite,
        isTestSeriesAndEnrolledPage
    ]);
    if (!course) return null;
    var isLive = course.isLive, isOngoing = course.isOngoing;
    var handleEnroll = function(e) {
        e.stopPropagation();
        e.preventDefault();
        toggleEnroll(course.uid, isEnrolledInCourse, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z)({}, goalSegmentData, segmentData), isRecordedGoal);
    };
    var ThumbnailTags = function() {
        var ref;
        var showProgressbar = isLoggedIn && isSubscribed && course.itemCount > 0 && showProgress;
        var showLiveAtTag = isOngoing && !isLive && (0,_utils_dates__WEBPACK_IMPORTED_MODULE_9__/* .isSameDay */ .KC)(new Date((ref = course.nextTrack) === null || ref === void 0 ? void 0 : ref.liveAtString), new Date());
        var showEnrollButton = !course.showAsLesson && !course.isSpecial && (course.forPlus || type === "syllabus") && !!toggleEnroll;
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .Fragment */ .HY, {
            children: [
                showEnrollButton && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsx */ .tZ)(_CourseCard__WEBPACK_IMPORTED_MODULE_27__/* .EnrollButton */ .a0, {
                    onClick: isSubscribed || isSubscribedToLite && isTestSeriesAndEnrolledPage ? handleEnroll : undefined,
                    iconProps: {
                        hovDisabled: true
                    },
                    isEnrolled: isEnrolledInCourse,
                    disableHover: !isSubscribed,
                    dataAnalytics: "".concat(dataAnalytics, "-courseEnroll"),
                    children: renderIconButton
                }),
                !showProgressbar && showLiveAtTag && course.nextTrack.liveAtString && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsx */ .tZ)(_CourseCard__WEBPACK_IMPORTED_MODULE_27__/* .StyledTag */ .w5, {
                    type: "filled",
                    children: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_9__/* .getTime */ .hK)(course.nextTrack.liveAtString)
                }),
                !showProgressbar && isLive && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsx */ .tZ)(_CourseCard__WEBPACK_IMPORTED_MODULE_27__/* .StyledTag */ .w5, {
                    type: "live",
                    children: "Live"
                }),
                showProgressbar && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .Fragment */ .HY, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsx */ .tZ)(CourseProgressbar, {
                            width: "100%",
                            value: course.lessonsCompleted / course.itemCount * 100,
                            backgroundColor: "var(--color-overlay)",
                            overlayColor: "var(--color-i-green)"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsxs */ .BX)(TagsWrapper, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsx */ .tZ)(ProgressTag, {
                                    type: "filled",
                                    children: "".concat(course.lessonsCompleted, " / ").concat(course.itemCount, " COMPLETED")
                                }),
                                showLiveAtTag && course.nextTrack.liveAtString && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsx */ .tZ)(Tag, {
                                    type: "filled",
                                    children: (0,_utils_dates__WEBPACK_IMPORTED_MODULE_9__/* .getTime */ .hK)(course.nextTrack.liveAtString)
                                }),
                                isLive && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsx */ .tZ)(Tag, {
                                    type: "live",
                                    children: "Live"
                                })
                            ]
                        })
                    ]
                })
            ]
        });
    };
    var handleAnalytics = function() {
        var courseData = course || {};
        var courseUID = courseData.uid || "";
        // Means card was rendered on a search page
        if (course.showAsLesson) {
            _actions_analytics__WEBPACK_IMPORTED_MODULE_14__/* .segment.track */ .EX.track("Lesson Viewed", {
                last_primary_source: lastPrimarySource,
                last_primary_source_section: label
            });
        }
        if (type === "search") {
            var nSearchData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z)({}, searchData);
            delete nSearchData.query;
            var position = nSearchData.position ? nSearchData.position : "See all";
            // send segment search result clicked event
            _actions_analytics__WEBPACK_IMPORTED_MODULE_14__/* .segment.track */ .EX.track(_constants_segment__WEBPACK_IMPORTED_MODULE_21__/* .SEARCH_RESULT_CLICKED */ .dW7, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z)({}, goalSegmentData), {
                sub_position: index + 1,
                is_object_plus: courseData.forPlus,
                is_object_special: courseData.isSpecial,
                educator_uid: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_19__/* .getCommaSeparatedUIDs */ .$V)(authors),
                educator_username: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_19__/* .getCommaSeparatedUIDs */ .$V)(authors, "username"),
                educator_name: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_19__/* .getCommaSeparatedUIDs */ .$V)(authors, "name"),
                last_primary_source: _constants_segment__WEBPACK_IMPORTED_MODULE_21__/* .SEARCH_RESULT_PAGE */ .jDH,
                last_primary_source_section: "Courses",
                search_section: "Global",
                current_screen: "Courses",
                eventName: _constants_segment__WEBPACK_IMPORTED_MODULE_21__/* .SEARCH_RESULT_CLICKED */ .dW7,
                eventType: "click",
                version: 2,
                objectID: "".concat(searchData.object_type, ":").concat(courseUID),
                userToken: meUID
            }), nSearchData), {
                position: position
            }), _constants_index__WEBPACK_IMPORTED_MODULE_20__/* .evtNameCategoryMap.WITHOUT_CATEGORY */ .xK.WITHOUT_CATEGORY);
            (0,_api_fetchers_search_search__WEBPACK_IMPORTED_MODULE_26__/* .updateRecentSearchLog */ .a)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_34__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z)({}, searchData), {
                entity_id: "".concat(searchData.object_type, ":").concat(courseUID),
                goal_uid: goalUID
            }));
        }
        var info = {
            index: index,
            "Last Primary Source": lastPrimarySource
        };
        info["Last Primary Source Section"] = label || _events_segmentStorage__WEBPACK_IMPORTED_MODULE_12__/* ["default"].getItem */ .Z.getItem("lpss");
        if (lastPrimarySource === "lesson page") {
            _actions_analytics__WEBPACK_IMPORTED_MODULE_14__/* .segment.track */ .EX.track(course.isSpecial ? "CLX Lesson View" : "Course Viewed", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_33__/* ["default"] */ .Z)({
                last_primary_source: lastPrimarySource,
                last_primary_source_section: label,
                course_uid: course.uid,
                course_title: course.name,
                start_date: course.startsAt,
                end_date: course.endsAt,
                educator_uid: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_19__/* .wordsToSentence */ .nt)(course.authors, "uid", ",", ","),
                educator_username: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_19__/* .wordsToSentence */ .nt)(course.authors, "username", ",", ","),
                is_offline_course: (courseData === null || courseData === void 0 ? void 0 : courseData.courseType) === _constants_index__WEBPACK_IMPORTED_MODULE_20__/* .programmeTypes.HYBRID_COURSE */ .h7.HYBRID_COURSE
            }, goalSegmentData));
        }
        // Adding LPSS to segment from label property and deleting it on class exit
        // in case property is not deleted removing it if label is not passed
        if (label) _events_segmentStorage__WEBPACK_IMPORTED_MODULE_12__/* ["default"].setItem */ .Z.setItem("lpss", label);
        else _events_segmentStorage__WEBPACK_IMPORTED_MODULE_12__/* ["default"].deleteItem */ .Z.deleteItem("lpss");
        onCardClick();
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsxs */ .BX)(CardContainer, {
        className: className,
        gridColumn: gridColumn,
        orientation: orientation,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsx */ .tZ)(_base_Link_Link__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                href: (0,_models_Course__WEBPACK_IMPORTED_MODULE_10__/* .getLinkPath */ .bc)(course),
                as: (0,_models_Course__WEBPACK_IMPORTED_MODULE_10__/* .getLink */ .Rg)(course),
                onClick: handleAnalytics,
                className: "card-link",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .Fragment */ .HY, {
                    children: coverPhoto ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsx */ .tZ)(CourseThumbnail, {
                        width: 272,
                        height: 152,
                        layout: "intrinsic",
                        alt: course.newThumbnail ? "new-thumbnail" : "thumbnail",
                        imgUrl: coverPhoto,
                        orientation: orientation,
                        borderRadius: imageBorderRadius,
                        "data-analytics": "".concat(dataAnalytics, "-courseCard"),
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsx */ .tZ)(ThumbnailTags, {})
                    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsxs */ .BX)(SvgCourseThumbnail, {
                        as: DefaultThumbnail,
                        $orientation: orientation,
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsx */ .tZ)(PlaceholderThumbnail, {
                                color: color
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsx */ .tZ)(ThumbnailTags, {})
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_32__/* .jsx */ .tZ)(_PlusCourseCardDetails__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, {
                handleAnalytics: handleAnalytics,
                orientation: orientation,
                course: course,
                cardType: cardType,
                topic: topic,
                searchData: searchData,
                type: type,
                disabledTopicGroup: disabledTopicGroup,
                hideLessonCount: hideLessonCount
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (PlusCourseCard);
PlusCourseCard.propTypes = {
    gridColumn: (prop_types__WEBPACK_IMPORTED_MODULE_35___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_35___default().string),
    orientation: prop_types__WEBPACK_IMPORTED_MODULE_35___default().oneOf([
        "horizontal",
        "vertical"
    ]),
    course: prop_types__WEBPACK_IMPORTED_MODULE_35___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_35___default().unknown)).isRequired,
    toggleEnroll: (prop_types__WEBPACK_IMPORTED_MODULE_35___default().func.isRequired),
    cardType: (prop_types__WEBPACK_IMPORTED_MODULE_35___default().string),
    topic: prop_types__WEBPACK_IMPORTED_MODULE_35___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_35___default().unknown)),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_35___default().string),
    imageBorderRadius: (prop_types__WEBPACK_IMPORTED_MODULE_35___default().string),
    showProgress: (prop_types__WEBPACK_IMPORTED_MODULE_35___default().bool),
    dataAnalytics: (prop_types__WEBPACK_IMPORTED_MODULE_35___default().string),
    index: (prop_types__WEBPACK_IMPORTED_MODULE_35___default().number.isRequired),
    label: (prop_types__WEBPACK_IMPORTED_MODULE_35___default().string),
    lastPrimarySource: (prop_types__WEBPACK_IMPORTED_MODULE_35___default().string),
    searchData: prop_types__WEBPACK_IMPORTED_MODULE_35___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_35___default().unknown)),
    disabledTopicGroup: (prop_types__WEBPACK_IMPORTED_MODULE_35___default().bool),
    isEnrolled: (prop_types__WEBPACK_IMPORTED_MODULE_35___default().bool),
    hideLessonCount: (prop_types__WEBPACK_IMPORTED_MODULE_35___default().bool),
    onCardClick: (prop_types__WEBPACK_IMPORTED_MODULE_35___default().func)
};
PlusCourseCard.defaultProps = {
    gridColumn: "span 6",
    className: "",
    orientation: "vertical",
    cardType: "all_cards",
    topic: {},
    type: "",
    imageBorderRadius: "0px",
    showProgress: false,
    dataAnalytics: "",
    lastPrimarySource: "",
    label: "",
    searchData: {},
    disabledTopicGroup: false,
    isEnrolled: false,
    hideLessonCount: false,
    onCardClick: function() {}
};


/***/ }),

/***/ 26391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony export getLiveAtTIme */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(35944);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_18___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_18__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var _base_Grow_Grow__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5010);
/* harmony import */ var _base_P2_P2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72560);
/* harmony import */ var _base_H6_H6__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10076);
/* harmony import */ var _base_Tags_Tags__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(52236);
/* harmony import */ var _base_Link_Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76356);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(97428);
/* harmony import */ var _models_Course__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56046);
/* harmony import */ var _models_User__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(81570);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(2080);
/* harmony import */ var _stores_AppCommonData__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(83995);
/* harmony import */ var _cont_Syllabus_constants_getTopicGroupAssetObj__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(77608);
/* harmony import */ var _api_selectors_constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(17064);
/* harmony import */ var _api_hooks_useConstants__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(79917);
/* harmony import */ var _api_processors_search__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(26046);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(31309);
/* harmony import */ var _util__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(53915);



















var Wrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "ebj1ggr0",
    label: "Wrapper"
})("display:flex;flex:1;flex-direction:column;justify-content:space-between;background-color:var(--color-base-1);text-align:left;padding:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_4B */ .t8.BM, " ", function(param) {
    var orientation = param.orientation;
    return orientation === "horizontal" ? _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_6B */ .t8.BY : _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_4B */ .t8.BM;
}, ";");
var TopicGroupTag = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_Tags_Tags__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    target: "ebj1ggr1",
    label: "TopicGroupTag"
})("text-overflow:ellipsis;white-space:nowrap;overflow:hidden;padding:0;width:100%;max-width:none;color:", function(param) {
    var color = param.color;
    return color;
}, ";@media only screen and (max-width:47.95em){font-size:10px;}");
var BreadCrumbs = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])("div", {
    target: "ebj1ggr2",
    label: "BreadCrumbs"
})("padding-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_2B */ .t8.Rw, ";display:grid;grid-template-columns:max-content 1fr;grid-column-gap:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_2B */ .t8.Rw, ";align-items:center;@media only screen and (max-width:47.95em){padding-bottom:4px;}");
var CourseTitle = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_H6_H6__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    target: "ebj1ggr3",
    label: "CourseTitle"
})("padding-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_1B */ .t8.MK, ";color:var(--color-text-primary);@media only screen and (max-width:47.95em){padding-bottom:0;font-size:16px;}");
var CourseInfo = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_P2_P2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "ebj1ggr4",
    label: "CourseInfo"
})("padding-top:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_1B */ .t8.MK, ";padding-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_1B */ .t8.MK, ";@media only screen and (max-width:47.95em){padding-bottom:0;margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_4B */ .t8.BM, ";}");
var EducatorName = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_P2_P2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    target: "ebj1ggr5",
    label: "EducatorName"
})("padding-top:", _styles_index__WEBPACK_IMPORTED_MODULE_9__/* .Spacings.SPACING_2B */ .t8.Rw, ";color:var(--color-text-primary);");
var getLiveAtTIme = function(liveAtString) {
    return liveAtString ? (0,_utils_dates__WEBPACK_IMPORTED_MODULE_6__/* .getTime */ .hK)(liveAtString) : "";
};
var getAuthorInfo = function() {
    var course = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var ref, ref1, ref2, ref3, ref4;
    var author = course.author, authors = course.authors;
    var authorID = (authors === null || authors === void 0 ? void 0 : (ref = authors[0]) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : ref1.relative_link) || (author === null || author === void 0 ? void 0 : author.relativeLink);
    if (!authorID && ((authors === null || authors === void 0 ? void 0 : (ref2 = authors[0]) === null || ref2 === void 0 ? void 0 : ref2.username) || (author === null || author === void 0 ? void 0 : author.username))) authorID = "/@".concat((authors === null || authors === void 0 ? void 0 : (ref3 = authors[0]) === null || ref3 === void 0 ? void 0 : ref3.username) || (author === null || author === void 0 ? void 0 : author.username));
    var authorName = (authors === null || authors === void 0 ? void 0 : (ref4 = authors[0]) === null || ref4 === void 0 ? void 0 : ref4.name) || (0,_api_processors_search__WEBPACK_IMPORTED_MODULE_14__/* .getAuthorFullName */ .O)(author);
    return {
        authorID: authorID,
        authorName: authorName
    };
};
var PlusCourseCardDetails = function(param) {
    var orientation = param.orientation, course = param.course, showScheduleInfo = param.showScheduleInfo, cardType = param.cardType, topic = param.topic, handleAnalytics = param.handleAnalytics, disabledTopicGroup = param.disabledTopicGroup, hideLessonCount = param.hideLessonCount;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var isMobile = (0,_stores_AppCommonData__WEBPACK_IMPORTED_MODULE_10__/* .useIsMobile */ .dD)();
    var isGTP = (0,_api_hooks_useConstants__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)((0,_api_selectors_constants__WEBPACK_IMPORTED_MODULE_12__/* .getIsGTPGoal */ .vf)((ref = course.goal) === null || ref === void 0 ? void 0 : ref.uid));
    if (!course) return null;
    var language = course.language, name = course.name, topicGroups = course.topicGroups, topicName = course.topic, showAsLesson = course.showAsLesson, nextTrack = course.nextTrack, programme = course.programme, isSpecial = course.isSpecial;
    var ref7 = getAuthorInfo(course), authorID = ref7.authorID, authorName = ref7.authorName;
    var isOnlyRecordedClassesPresent = (0,_util__WEBPACK_IMPORTED_MODULE_16__/* .getIsOnlyRecordedClassesPresent */ .a5)(programme) || (0,_util__WEBPACK_IMPORTED_MODULE_16__/* .getIsOnlyRecordedClassesPresent */ .a5)(course);
    var onlyShowLessonsCount = isOnlyRecordedClassesPresent && !isSpecial;
    var courseInfo = (0,_util__WEBPACK_IMPORTED_MODULE_16__/* .getCourseInfo */ .zf)(hideLessonCount, course);
    var getPreviouslyEnrolledCourseInfo = function() {
        var ref;
        var isOngoing = course.isOngoing, isCompleted = course.isCompleted, isUpcoming = course.isUpcoming, isLive = course.isLive, itemCount = course.itemCount;
        if (onlyShowLessonsCount) return "".concat((0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_15__/* .pluralize */ ._6)(itemCount, "session"));
        var liveAtString = nextTrack.liveAtString || (nextTrack === null || nextTrack === void 0 ? void 0 : (ref = nextTrack.properties) === null || ref === void 0 ? void 0 : ref.liveAt);
        var liveLessonStartTime = new Date(liveAtString);
        if (isLive) {
            return "Started at ".concat(getLiveAtTIme(liveAtString));
        }
        if (isOngoing) {
            var isToday = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_6__/* .isSameDay */ .KC)(liveLessonStartTime, new Date());
            if (isToday) return "Today, ".concat(getLiveAtTIme(liveAtString));
            return "".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_6__/* .getFullDate */ .xE)(liveAtString), " ").concat(getLiveAtTIme(liveAtString));
        }
        if (isUpcoming) {
            var startsAt = course.startsAt;
            return "Starts on ".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_6__/* .getFullDate */ .xE)(startsAt), " ");
        }
        if (isCompleted) {
            var endsAt = course.endsAt;
            return "Ended on ".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_6__/* .getFullDate */ .xE)(endsAt), " ");
        }
    };
    var userIsLegendEducator = course.authors && (0,_models_User__WEBPACK_IMPORTED_MODULE_8__/* .isLegendEducator */ .HQ)(course.authors[0]);
    var topicData = {
        uid: topicGroups === null || topicGroups === void 0 ? void 0 : (ref1 = topicGroups[0]) === null || ref1 === void 0 ? void 0 : ref1.uid,
        name: (topicGroups === null || topicGroups === void 0 ? void 0 : (ref2 = topicGroups[0]) === null || ref2 === void 0 ? void 0 : ref2.name) || (topicGroups === null || topicGroups === void 0 ? void 0 : (ref3 = topicGroups[0]) === null || ref3 === void 0 ? void 0 : ref3.title) || topicName || ""
    };
    var displayName = showAsLesson ? nextTrack.name : name;
    if (topic && topic.uid) {
        topicData = {
            uid: topic.uid,
            name: topic.name || topicName
        };
    }
    var color = (0,_cont_Syllabus_constants_getTopicGroupAssetObj__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(topicData.name).color;
    var onTopicClick = function(e) {
        if (isMobile) {
            e.preventDefault();
        }
    };
    var handleCourseClick = function() {
        handleAnalytics();
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)(Wrapper, {
        orientation: orientation,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)("div", {
                children: [
                    !userIsLegendEducator ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)(BreadCrumbs, {
                        children: [
                            language && language !== "" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_base_Tags_Tags__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                                type: "hollow",
                                children: language
                            }) : null,
                            (topicData === null || topicData === void 0 ? void 0 : topicData.uid) || (topicData === null || topicData === void 0 ? void 0 : topicData.name) ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .Fragment */ .HY, {
                                children: disabledTopicGroup ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(TopicGroupTag, {
                                    type: "transparent",
                                    color: color,
                                    children: topicData.name
                                }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_base_Link_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    href: "/goal/[goalSlug]/[goalUID]/topic/[topicUid]",
                                    as: "/goal/".concat(((ref4 = course.goal) === null || ref4 === void 0 ? void 0 : ref4.goalSlug) || ((ref5 = course.goal) === null || ref5 === void 0 ? void 0 : ref5.slug), "/").concat((ref6 = course.goal) === null || ref6 === void 0 ? void 0 : ref6.uid, "/topic/").concat(topicData.uid),
                                    anchorStyle: "display: inline-block;min-width: 0;line-height: 1;",
                                    onClick: onTopicClick,
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(TopicGroupTag, {
                                        type: "transparent",
                                        color: color,
                                        children: topicData.name
                                    })
                                })
                            }) : null
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_base_Link_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        href: (0,_models_Course__WEBPACK_IMPORTED_MODULE_7__/* .getLinkPath */ .bc)(course),
                        as: (0,_models_Course__WEBPACK_IMPORTED_MODULE_7__/* .getLink */ .Rg)(course),
                        onClick: handleCourseClick,
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(CourseTitle, {
                            lineClamp: 2,
                            as: "h4",
                            "data-testid": "course-tile-plus-card",
                            children: displayName
                        })
                    }),
                    showScheduleInfo && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .Fragment */ .HY, {
                        children: courseInfo ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)(CourseInfo, {
                            color: "var(--color-text-secondary)",
                            "data-testid": "course-info",
                            children: [
                                cardType === "all_cards" && courseInfo,
                                cardType === "previouslyEnrolled" && getPreviouslyEnrolledCourseInfo()
                            ]
                        }) : null
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_base_Grow_Grow__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {}),
            !isGTP && authorID ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_base_Link_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                href: "/[authorID]",
                as: authorID,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(EducatorName, {
                    as: "h4",
                    "data-testid": "educator-name",
                    children: authorName
                })
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(EducatorName, {
                as: "h4",
                children: authorName
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PlusCourseCardDetails);
PlusCourseCardDetails.propTypes = {
    orientation: (prop_types__WEBPACK_IMPORTED_MODULE_18___default().string.isRequired),
    course: prop_types__WEBPACK_IMPORTED_MODULE_18___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_18___default().unknown)).isRequired,
    showScheduleInfo: (prop_types__WEBPACK_IMPORTED_MODULE_18___default().bool),
    cardType: (prop_types__WEBPACK_IMPORTED_MODULE_18___default().string),
    topic: prop_types__WEBPACK_IMPORTED_MODULE_18___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_18___default().unknown)),
    handleAnalytics: (prop_types__WEBPACK_IMPORTED_MODULE_18___default().func),
    disabledTopicGroup: (prop_types__WEBPACK_IMPORTED_MODULE_18___default().bool),
    hideLessonCount: (prop_types__WEBPACK_IMPORTED_MODULE_18___default().bool)
};
PlusCourseCardDetails.defaultProps = {
    showScheduleInfo: true,
    cardType: "all_cards",
    topic: {},
    handleAnalytics: function() {},
    disabledTopicGroup: false,
    hideLessonCount: false
};


/***/ }),

/***/ 13272:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52420);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_21___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_21__);
/* harmony import */ var _base_Grow_Grow__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5010);
/* harmony import */ var _base_P2_P2__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72560);
/* harmony import */ var _base_H6_H6__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(10076);
/* harmony import */ var _base_Link_Link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(76356);
/* harmony import */ var _base_Tags_Tags__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52236);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(97428);
/* harmony import */ var _utils_isEmptyObject__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(9759);
/* harmony import */ var _utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(87312);
/* harmony import */ var _actions_analytics__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(87936);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(43135);
/* harmony import */ var _constants_segment__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17579);
/* harmony import */ var _utils_textHelper__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31309);
/* harmony import */ var _hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(52405);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(2080);
/* harmony import */ var _api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(85780);
/* harmony import */ var _api_selectors_auth__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(73060);






















var Live = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_Tags_Tags__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    target: "efwjpcb0",
    label: "Live"
})("margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_14__/* .Spacings.SPACING_3B */ .t8.N, ";@media (max-width:47.95em){margin-top:16px;}");
var Title = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_base_H6_H6__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    target: "efwjpcb1",
    label: "Title"
})("@media (max-width:47.95em){font-size:16px;}");
var getInfoString = function(test) {
    var nextTrack = test.nextTrack, isCompleted = test.isCompleted;
    if (isCompleted) return "Ended on ".concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_7__/* .getDateShort */ .uK)(test.endsAt));
    if (!nextTrack || (0,_utils_isEmptyObject__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z)(nextTrack)) return null;
    return "".concat(nextTrack.type === "quiz" ? "Test" : "Lesson", " ").concat(nextTrack.contentRank || nextTrack.rank, " \u2022 ").concat((0,_utils_dates__WEBPACK_IMPORTED_MODULE_7__/* .dateWithTime */ .tZ)(nextTrack.type === "quiz" ? nextTrack.startsAt || nextTrack.startTime : nextTrack.liveAt || nextTrack.liveTime));
};
var renderBottom = function(test) {
    var isCompleted = test.isCompleted;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_base_Grow_Grow__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(_base_P2_P2__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                color: isCompleted ? "var(--color-text-secondary)" : "var(--color-text-primary)",
                children: getInfoString(test)
            })
        ]
    });
};
var TestSeriesCard = function(param) {
    var test = param.test, gridColumn = param.gridColumn, linkStyle = param.linkStyle, dataAnalytics = param.dataAnalytics, orientation = param.orientation, index = param.index, type = param.type, updateRecentSearchLog = param.updateRecentSearchLog, searchData = param.searchData, className = param.className;
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var goalSegmentData = (0,_hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({});
    var meUID = (0,_api_hooks_auth_useMyInfo__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(_api_selectors_auth__WEBPACK_IMPORTED_MODULE_18__/* .getMeUid */ .Up);
    var name = test.name, isLive = test.isLive, slug = test.slug, uid = test.uid, colorCode = test.colorCode, isSpecial = test.isSpecial, authors = test.authors;
    var asPath = "/test-series/".concat(slug, "/").concat(uid);
    var styledLink = "background-color: var(--color-base-1);\n  grid-column: ".concat(gridColumn, ";\n  padding: ").concat(_styles_index__WEBPACK_IMPORTED_MODULE_14__/* .Spacings.SPACING_4B */ .t8.BM, ";\n  border-radius: ").concat(_styles_index__WEBPACK_IMPORTED_MODULE_14__/* .Spacings.SPACING_2B */ .t8.Rw, ";\n  border-top: ").concat(_styles_index__WEBPACK_IMPORTED_MODULE_14__/* .Spacings.SPACING_2B */ .t8.Rw, " ").concat(_styles_index__WEBPACK_IMPORTED_MODULE_14__/* .SOLID_BORDER_STYLE */ .T_, " ").concat(colorCode, ";\n  cursor: pointer;\n  display: flex;\n  flex: 1;\n  height: 170px;\n  flex-direction:").concat(orientation === "vertical" ? "column" : "row", " ;\n  align-items: flex-start;\n  box-shadow: ").concat((0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(), ";\n  :hover {\n    box-shadow: ").concat((0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        yOffset: _styles_index__WEBPACK_IMPORTED_MODULE_14__/* .Spacings.SPACING_1B */ .t8.MK,
        blur: _styles_index__WEBPACK_IMPORTED_MODULE_14__/* .Spacings.SPACING_2B */ .t8.Rw
    }), ";\n  }\n  transition: box-shadow 0.2s ease-in-out;");
    var handleAnalytics = function() {
        var testData = test || {};
        var testUID = testData.uid || "";
        _actions_analytics__WEBPACK_IMPORTED_MODULE_9__/* .segment.track */ .EX.track(_constants_segment__WEBPACK_IMPORTED_MODULE_11__/* .TEST_SERIES_SECTION_CLICKED */ .b8R, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, goalSegmentData), {
            index: index,
            object_type: _constants_segment__WEBPACK_IMPORTED_MODULE_11__/* .searchObjectTypes.testSeries */ .DWc.testSeries,
            object_id: testUID,
            is_plus: testData.forPlus,
            is_special: testData.isSpecial,
            educator_uid: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_12__/* .getCommaSeparatedUIDs */ .$V)(authors),
            educator_username: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_12__/* .getCommaSeparatedUIDs */ .$V)(authors, "username"),
            educator_name: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_12__/* .getCommaSeparatedUIDs */ .$V)(authors, "name")
        }));
        if (type === "search") {
            var nSearchData = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, searchData);
            delete nSearchData.query;
            var position = nSearchData.position ? nSearchData.position : "See all";
            _actions_analytics__WEBPACK_IMPORTED_MODULE_9__/* .segment.track */ .EX.track(_constants_segment__WEBPACK_IMPORTED_MODULE_11__/* .SEARCH_RESULT_CLICKED */ .dW7, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, goalSegmentData), {
                sub_position: index + 1,
                is_object_plus: testData.forPlus,
                is__object_special: testData.isSpecial,
                educator_uid: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_12__/* .getCommaSeparatedUIDs */ .$V)(authors),
                educator_username: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_12__/* .getCommaSeparatedUIDs */ .$V)(authors, "username"),
                educator_name: (0,_utils_textHelper__WEBPACK_IMPORTED_MODULE_12__/* .getCommaSeparatedUIDs */ .$V)(authors, "name"),
                last_primary_source: _constants_segment__WEBPACK_IMPORTED_MODULE_11__/* .SEARCH_RESULT_PAGE */ .jDH,
                last_primary_source_section: "Test-series",
                search_section: "Global",
                current_screen: "Test-series",
                eventName: _constants_segment__WEBPACK_IMPORTED_MODULE_11__/* .SEARCH_RESULT_CLICKED */ .dW7,
                eventType: "click",
                version: 2,
                objectID: "".concat(searchData.entity_type, ":").concat(testUID),
                userToken: meUID
            }), nSearchData), {
                position: position
            }), _constants_index__WEBPACK_IMPORTED_MODULE_10__/* .evtNameCategoryMap.WITHOUT_CATEGORY */ .xK.WITHOUT_CATEGORY);
            dispatch(updateRecentSearchLog((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, searchData), {
                entity_id: "programme:".concat(testUID),
                goal_uid: test.goalUid || test.goal.uid
            })));
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsxs */ .BX)(_base_Link_Link__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        as: asPath,
        href: "/test-series/[slug]/[courseUID]",
        anchorStyle: styledLink + linkStyle,
        onClick: handleAnalytics,
        className: className,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(Title, {
                color: "var(--color-text-primary)",
                lineClamp: 2,
                "data-analytics": "".concat(dataAnalytics, "-courseCard"),
                as: "h4",
                children: name
            }),
            isLive ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(Live, {
                type: "live",
                children: "LIVE"
            }) : null,
            !isLive && isSpecial ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_17__/* .jsx */ .tZ)(Live, {
                type: "live",
                children: "FREE"
            }) : null,
            renderBottom(test)
        ]
    });
};
TestSeriesCard.propTypes = {
    test: prop_types__WEBPACK_IMPORTED_MODULE_21___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_21___default().any)).isRequired,
    gridColumn: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().string),
    linkStyle: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().string),
    dataAnalytics: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().string),
    index: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().number.isRequired),
    orientation: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().string),
    updateRecentSearchLog: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().func),
    searchData: prop_types__WEBPACK_IMPORTED_MODULE_21___default().objectOf((prop_types__WEBPACK_IMPORTED_MODULE_21___default().any)),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_21___default().string)
};
TestSeriesCard.defaultProps = {
    gridColumn: "span 6",
    linkStyle: "",
    dataAnalytics: "",
    orientation: "vertical",
    type: "",
    updateRecentSearchLog: function() {},
    searchData: {},
    className: ""
};
/* harmony default export */ __webpack_exports__["Z"] = (TestSeriesCard);


/***/ }),

/***/ 54029:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_20___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_20__);
/* harmony import */ var _actions_analytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87936);
/* harmony import */ var aquilla_core_molecules_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92378);
/* harmony import */ var aquilla_core_molecules_IconButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97985);
/* harmony import */ var _constants_segment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17579);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43135);
/* harmony import */ var _icon_Share__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(52324);
/* harmony import */ var _hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52405);
/* harmony import */ var _hooks_useAllTypesOfCourseEventProps__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(96780);
/* harmony import */ var _comp_ShareDialog_ShareDialog__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(74067);
/* harmony import */ var _comp_Dialog_Dialog__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(76920);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(2080);
/* harmony import */ var _api_hooks_batch_useBatchDetails__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(64465);
/* harmony import */ var _stores_AppCommonData__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(83995);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(73993);





















var StyledShareIcon = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_icon_Share__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    target: "e16zhcn0",
    label: "StyledShareIcon"
})("margin-bottom:-", _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_1B */ .t8.MK, ";");
var StyledButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(aquilla_core_molecules_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
    target: "e16zhcn1",
    label: "StyledButton"
})("width:", function(param) {
    var $fullWidth = param.$fullWidth;
    return $fullWidth ? "100%" : "auto";
}, ";");
var BatchShare = function(param) {
    var batchUID = param.batchUID, batch = param.batch, _isPrimaryBatchEnabled = param.isPrimaryBatchEnabled, isPrimaryBatchEnabled = _isPrimaryBatchEnabled === void 0 ? false : _isPrimaryBatchEnabled, _isIconButton = param.isIconButton, isIconButton = _isIconButton === void 0 ? false : _isIconButton, hasStorePurchase = param.hasStorePurchase;
    var ref;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showShareOptions = ref1[0], setShowShareOptions = ref1[1];
    var closeShareOptiopns = function() {
        return setShowShareOptions(false);
    };
    var batchDetails = (0,_api_hooks_batch_useBatchDetails__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(batchUID).batchDetails;
    var batchGoalUID = batchDetails === null || batchDetails === void 0 ? void 0 : (ref = batchDetails.goal) === null || ref === void 0 ? void 0 : ref.uid;
    var isSellable = batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.isSellable;
    var isMobile = (0,_stores_AppCommonData__WEBPACK_IMPORTED_MODULE_14__/* .useIsMobile */ .dD)();
    var goalSegmentData = (0,_hooks_useGoalEventProps__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        goalUID: batchGoalUID
    });
    var segmentData = (0,_hooks_useAllTypesOfCourseEventProps__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        course: batchDetails,
        isBatch: true
    });
    var route = (0,next_router__WEBPACK_IMPORTED_MODULE_15__.useRouter)().route;
    var isStoreRoute = (0,_utils__WEBPACK_IMPORTED_MODULE_16__/* .getIsStorePath */ .nQ)(route);
    var handleShare = function() {
        _actions_analytics__WEBPACK_IMPORTED_MODULE_2__/* .segment.track */ .EX.track(_constants_segment__WEBPACK_IMPORTED_MODULE_5__/* .BATCH_SHARED */ .fU0, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)({}, goalSegmentData, segmentData), {
            batch_state: batchDetails.state,
            last_primary_source: isStoreRoute ? "Store" : "Goal Home",
            is_sellable: isSellable,
            is_purchased: hasStorePurchase,
            is_store_exclusive: batchDetails === null || batchDetails === void 0 ? void 0 : batchDetails.isStoreExclusive
        }), _constants_index__WEBPACK_IMPORTED_MODULE_6__/* .evtNameCategoryMap.WITHOUT_CATEGORY */ .xK.WITHOUT_CATEGORY, true, _constants_segment__WEBPACK_IMPORTED_MODULE_5__/* .BATCH_KEYS */ .A8$);
        setShowShareOptions(true);
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__/* .Fragment */ .HY, {
        children: [
            isIconButton && !isMobile ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__/* .jsx */ .tZ)(aquilla_core_molecules_IconButton__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                variant: "secondary",
                color: "white",
                size: "medium",
                onClick: handleShare,
                $marginTop: isPrimaryBatchEnabled ? 0 : _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_3B */ .t8.N,
                isIconButton: true,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__/* .jsx */ .tZ)(_icon_Share__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    size: _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_6B */ .t8.BY,
                    color: "var(--color-text-primary)"
                })
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__/* .jsx */ .tZ)(StyledButton, {
                variant: "secondary",
                startIcon: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__/* .jsx */ .tZ)(StyledShareIcon, {
                    size: _styles_index__WEBPACK_IMPORTED_MODULE_12__/* .Spacings.SPACING_5B */ .t8.zj,
                    color: "var(--color-text-primary)"
                }),
                onClick: handleShare,
                size: "large",
                $fullWidth: true,
                children: "Share"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__/* .jsx */ .tZ)(_comp_Dialog_Dialog__WEBPACK_IMPORTED_MODULE_11__["default"], {
                onClose: closeShareOptiopns,
                dialogState: showShareOptions,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_19__/* .jsx */ .tZ)(_comp_ShareDialog_ShareDialog__WEBPACK_IMPORTED_MODULE_10__["default"], {
                    data: batchUID ? batchDetails : batch
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BatchShare);
BatchShare.propTypes = {
    batchUID: (prop_types__WEBPACK_IMPORTED_MODULE_20___default().string.isRequired)
};


/***/ }),

/***/ 99465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$b": function() { return /* binding */ greetingTopSpacing; },
/* harmony export */   "Cj": function() { return /* binding */ eventPadding; },
/* harmony export */   "Du": function() { return /* binding */ timelineTopSpacing; },
/* harmony export */   "EV": function() { return /* binding */ GTP_SUBSCRIPTION; },
/* harmony export */   "UA": function() { return /* binding */ PLATFORM_SUBSCRIPTION; },
/* harmony export */   "UI": function() { return /* binding */ plannerItemTypeHeightMap; },
/* harmony export */   "ZL": function() { return /* binding */ dayTitleLeftSpacing; },
/* harmony export */   "cX": function() { return /* binding */ browseTopSpacing; },
/* harmony export */   "eg": function() { return /* binding */ PLUS_SUBSCRIPTION; },
/* harmony export */   "et": function() { return /* binding */ plannerItemTypes; },
/* harmony export */   "iH": function() { return /* binding */ eventHeightMap; },
/* harmony export */   "jb": function() { return /* binding */ classCardHeight; },
/* harmony export */   "z1": function() { return /* binding */ eventTopSpacing; }
/* harmony export */ });
/* unused harmony export daySpacing */
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14924);
/* harmony import */ var _constants_schedule__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(88268);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2080);



var plannerItemTypes = {
    EVENT: "event",
    TIMELINE: "timeline",
    DAY_TITLE: "day_title",
    GREETING: "greeting",
    SUBSCRIPTION_FEEDBACK: "subscription_feedback",
    SUBSCRIPTION_RENEWAL: "renewal_card",
    FEATURE_CARD: "feature_card",
    FEATURE_INTRODUCTION: "feature_introduction",
    FEATURE_AWARENESS: "feature_card",
    BROWSE: "browse",
    SUBSCRIPTION_FEEDBACK_V2: "subscription_feedback_v2",
    FREE_TRIAL_CARD: "trial_subscription",
    SKELETON_LOADER: "skeleton_loader"
};
var daySpacing = 20;
var timelineTopSpacing = 24;
var eventTopSpacing = 24;
var browseTopSpacing = 24;
var greetingTopSpacing = 20;
var classCardHeight = 162;
var dayTitleLeftSpacing = _styles_index__WEBPACK_IMPORTED_MODULE_1__/* .Spacings.SPACING_7B */ .t8.d5;
var _obj;
var plannerItemTypeHeightMap = (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.DAY_TITLE, 64), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.TIMELINE, 12 + timelineTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.BROWSE, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.GREETING, 72 + greetingTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.SUBSCRIPTION_FEEDBACK, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.SUBSCRIPTION_RENEWAL, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.FEATURE_INTRODUCTION, 168 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.FEATURE_AWARENESS, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.SUBSCRIPTION_FEEDBACK_V2, 160 + browseTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.SKELETON_LOADER, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj, plannerItemTypes.FREE_TRIAL_CARD, 212 + browseTopSpacing), _obj);
var _obj1;
var eventHeightMap = (_obj1 = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.CLASS */ .pt.CLASS, classCardHeight + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.CLASS_WITH_PRACTICE */ .pt.CLASS_WITH_PRACTICE, 222 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.TEST */ .pt.TEST, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.TEST_WITH_EDUCATOR */ .pt.TEST_WITH_EDUCATOR, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.QUIZ */ .pt.QUIZ, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.COMBAT */ .pt.COMBAT, 108 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.LIVE_INTERACTION */ .pt.LIVE_INTERACTION, 98 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.DAILY_PRACTICE_REMINDER */ .pt.DAILY_PRACTICE_REMINDER, 84 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.OPENHOUSE */ .pt.OPENHOUSE, 80 + eventTopSpacing), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_obj1, _constants_schedule__WEBPACK_IMPORTED_MODULE_0__/* .plannerEventTypes.OFFLINE_TEST */ .pt.OFFLINE_TEST, 136 + eventTopSpacing), _obj1);
var eventPadding = 16;
var PLUS_SUBSCRIPTION = "plus_subscription";
var PLATFORM_SUBSCRIPTION = "platform_subscription";
var GTP_SUBSCRIPTION = "gtp_subscription";


/***/ }),

/***/ 88322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$r": function() { return /* binding */ DAILY_GOALS_OPTIONS; },
/* harmony export */   "Fj": function() { return /* binding */ DPP_SET_REMINDER_CLICKED; },
/* harmony export */   "G8": function() { return /* binding */ TOOLTIP_MAP; },
/* harmony export */   "Jb": function() { return /* binding */ DPP_COMPLETED; },
/* harmony export */   "Jf": function() { return /* binding */ QUERY_ACTIONS; },
/* harmony export */   "Kd": function() { return /* binding */ MAX_PRACTICE_SESSION_COUNT; },
/* harmony export */   "LJ": function() { return /* binding */ DISLIKE_REASONS; },
/* harmony export */   "Lr": function() { return /* binding */ MIN_QUESTIONS; },
/* harmony export */   "MA": function() { return /* binding */ FEEDBACK_OPTIONS_MAPPING; },
/* harmony export */   "Ny": function() { return /* binding */ MODAL_TYPES; },
/* harmony export */   "R1": function() { return /* binding */ DPP_SET_REMINDER_CARD_VIEWED; },
/* harmony export */   "Sx": function() { return /* binding */ YEAR_FILTER_TYPE; },
/* harmony export */   "Up": function() { return /* binding */ noPrefrenceCode; },
/* harmony export */   "VL": function() { return /* binding */ REVIEW_TYPE; },
/* harmony export */   "Ws": function() { return /* binding */ PRACTICE_TYPE; },
/* harmony export */   "Xg": function() { return /* binding */ TIME_LAPSE_LIMIT; },
/* harmony export */   "Y8": function() { return /* binding */ practiceActionTypes; },
/* harmony export */   "ad": function() { return /* binding */ LANGUAGE; },
/* harmony export */   "cq": function() { return /* binding */ PRACTICE_MIN_QUESTION_NUM; },
/* harmony export */   "gi": function() { return /* binding */ DEFAULT_LANGUAGE_INFO; },
/* harmony export */   "jb": function() { return /* binding */ DEFAULT_DAILY_GOAL; },
/* harmony export */   "ki": function() { return /* binding */ SUBJECTS; },
/* harmony export */   "lz": function() { return /* binding */ DAILY_REMINDER_OPTIONS; },
/* harmony export */   "nI": function() { return /* binding */ PRACTICE_FLOW_TYPE; },
/* harmony export */   "oH": function() { return /* binding */ DPP_INCOMPLETE; },
/* harmony export */   "oZ": function() { return /* binding */ SKIP_REASONS; },
/* harmony export */   "pj": function() { return /* binding */ DEFAULT_TIME; },
/* harmony export */   "qu": function() { return /* binding */ DEFAULT_TIME_IN_TEXT; },
/* harmony export */   "xl": function() { return /* binding */ MAX_QUESTIONS; }
/* harmony export */ });
/* unused harmony exports getHoursOptions, getRoundedGTPPracticeQuestionCount, DPP_PREFERENCES_QUESTION, PRACTICE_SETTINGS_CLICKED */
/* harmony import */ var _constants_practice__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11238);
/* harmony import */ var _utils_dates__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97428);
/* harmony import */ var _utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(48821);



var noPrefrenceCode = -1;
var LANGUAGE = {
    ALL: {
        display_name: "All",
        code: 0
    }
};
var DEFAULT_LANGUAGE_INFO = {
    user_preference: 0,
    available_languages: [],
    language_selection_available: false
};
var PRACTICE_TYPE = {
    FULL: 1,
    EACH_TOPIC: 2,
    PYQ: 3,
    TEXTBOOK: 4,
    INCORRECT: 5
};
var PRACTICE_FLOW_TYPE = {
    NORMAL_PRACTICE: "1",
    CLASS_PRACTICE: "2",
    SYLLABUS_PRACTICE: "3",
    AUTO_DPP: "4"
};
var DISLIKE_REASONS = [
    "Mistake in the question/option choices",
    "Mistake in solution",
    "Technical issue",
    "Plagiarism"
];
var YEAR_FILTER_TYPE = {
    ALL: "all-filter"
};
var SKIP_REASONS = [
    {
        why: _constants_practice__WEBPACK_IMPORTED_MODULE_0__/* .SKIP_REASONS_MAP.DIFFICULT_QUESTION */ .X.DIFFICULT_QUESTION,
        icon: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .getImage */ .gJ)("practice-session/thinking-face.svg")
    },
    {
        why: _constants_practice__WEBPACK_IMPORTED_MODULE_0__/* .SKIP_REASONS_MAP.DIDNT_UNDERSTAND */ .X.DIDNT_UNDERSTAND,
        icon: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .getImage */ .gJ)("practice-session/confused.svg")
    },
    {
        why: _constants_practice__WEBPACK_IMPORTED_MODULE_0__/* .SKIP_REASONS_MAP.HAVENT_STUDIED */ .X.HAVENT_STUDIED,
        icon: (0,_utils_imageHelper__WEBPACK_IMPORTED_MODULE_2__/* .getImage */ .gJ)("practice-session/exclamation-question.svg")
    }
];
var REVIEW_TYPE = {
    POSITIVE: 1,
    NEGATIVE: 2
};
var SUBJECTS = {
    ALL: -1
};
var MAX_QUESTIONS = 30;
var MIN_QUESTIONS = 5;
var FEEDBACK_OPTIONS_MAPPING = {
    POSITIVE: {
        QUALITY_OF_SOLUTIONS: 496,
        QUALITY_OF_QUESTIONS: 497,
        MIX_OF_QUESTIONS: 498,
        INTERFACE: 499,
        SYLLABUS: 500
    },
    NEGATIVE: {
        QUALITY_OF_SOLUTIONS: 501,
        QUALITY_OF_QUESTIONS: 502,
        MIX_OF_QUESTIONS: 503,
        INTERFACE: 504,
        SYLLABUS: 505
    }
};
var DAILY_GOALS_OPTIONS = [
    {
        value: 10,
        label: "10 questions"
    },
    {
        value: 20,
        label: "20 questions"
    },
    {
        value: 30,
        label: "30 questions"
    }
];
var getHoursOptions = function() {
    var options = [];
    var ref = (0,_utils_dates__WEBPACK_IMPORTED_MODULE_1__/* .generateHours */ .SA)({
        interval: 30
    }), twentyFourHrFormat = ref.twentyFourHrFormat, twelveHrFormat = ref.twelveHrFormat;
    twelveHrFormat.forEach(function(hour, index) {
        options.push({
            value: twentyFourHrFormat[index],
            label: hour
        });
    });
    return options;
};
var DAILY_REMINDER_OPTIONS = getHoursOptions();
var MODAL_TYPES = {
    PRACTICE_REMINDER: "PRACTICE_REMINDER"
};
var QUERY_ACTIONS = {
    SHOW_REMINDER_SETTING: "show_reminder_setting"
};
var TOOLTIP_MAP = {
    TOTAL_QUESTION_LIMIT_REACHED: "Total questions limit reached",
    CANNOT_ADD_MORE_QUESTIONS: "Cannot add more questions",
    NULL: ""
};
var PRACTICE_MIN_QUESTION_NUM = 5;
var getRoundedGTPPracticeQuestionCount = function(count) {
    return Math.floor(count / 100) * 100;
};
var practiceActionTypes = {
    SET_REMINDER_DEFAULT_DATA: "SET_REMINDER_DEFAULT_DATA"
};
var MAX_PRACTICE_SESSION_COUNT = 5;
var TIME_LAPSE_LIMIT = 7;
var DEFAULT_DAILY_GOAL = 10;
var DEFAULT_TIME = "09:00";
var DEFAULT_TIME_IN_TEXT = "09:00 AM";
var DPP_SET_REMINDER_CARD_VIEWED = "DPP - Set Reminder Card Viewed ";
var DPP_SET_REMINDER_CLICKED = "DPP - Set Reminder Clicked";
var DPP_PREFERENCES_QUESTION = "DPP - Preferences Question";
var PRACTICE_SETTINGS_CLICKED = "Practice - Settings Clicked";
var DPP_COMPLETED = 1;
var DPP_INCOMPLETE = 0;


/***/ }),

/***/ 71800:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(35944);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_16___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_16__);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95934);
/* harmony import */ var _comp_UnderlineLink_UnderlineLink__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14233);
/* harmony import */ var _icon_ChevronLeft__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19927);
/* harmony import */ var _icon_ChevronRight__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91656);
/* harmony import */ var _base_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(42531);
/* harmony import */ var _utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(87312);
/* harmony import */ var _base_H4_H4__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64250);
/* harmony import */ var _base_P1_P1__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(85620);
/* harmony import */ var _base_Grow_Grow__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(5010);
/* harmony import */ var _hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(50420);
/* harmony import */ var _styles_index__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2080);
/* harmony import */ var _base_Button_Button__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(35415);
/* harmony import */ var _base_H3_H3__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(82034);
/* harmony import */ var _utils_pushRoute__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(751);

















var Column = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "ez7effk0",
    label: "Column"
})("display:flex;flex-direction:column;");
var GreenH4 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_H4_H4__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    target: "ez7effk1",
    label: "GreenH4"
})("font-weight:bold;font-size:20px;line-height:150%;color:var(--color-i-green);@media (max-width:70.95em){font-size:16px;}");
var StyH3 = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_H3_H3__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {
    target: "ez7effk2",
    label: "StyH3"
})("font-size:32px;@media (max-width:70.95em){font-size:22px;}@media (max-width:47.95em){padding:0 16px;}");
var SubLabel = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_P1_P1__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
    target: "ez7effk3",
    label: "SubLabel"
})("font-size:16px;margin-top:", _styles_index__WEBPACK_IMPORTED_MODULE_11__/* .Spacings.SPACING_3B */ .t8.N, ";@media (max-width:70.95em){margin-top:8px;}@media (max-width:47.95em){padding:0 16px;}");
var CarouselWrapper = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "ez7effk4",
    label: "CarouselWrapper"
})("position:relative;margin-left:-16px;margin-bottom:-32px;@media (max-width:47.95em){margin:0;overflow:hidden;}");
var CardContainer = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "ez7effk5",
    label: "CardContainer"
})("padding-bottom:32px;padding-left:16px;display:flex;& > a,& > div{transform:", function(param) {
    var pos = param.pos, addPadding = param.addPadding;
    return pos && "translate3d(calc(".concat(-100 * pos, "% - ").concat(pos * addPadding ? 24 * pos : 0, "px), 0, 0)") || "initial";
}, ";transition:transform 400ms ease-in,opacity 400ms ease-in;}@media (min-width:70.95em){overflow:hidden;}@media (max-width:47.95em){padding:0;padding-bottom:2.5rem;overflow:scroll;overscroll-behavior:unset;scroll-behavior:smooth;::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;& > div:first-child{margin-left:16px;}}");
var ControlButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_IconButton_IconButton__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
    target: "ez7effk6",
    label: "ControlButton"
})("position:absolute;/* turning off for now as suggested by design */\n  /* visibility:hidden;*/\n  /* opacity:0;*/\n  transition:visibility 0s linear 300ms,opacity 300ms;", function(param) {
    var height = param.height;
    return height ? "top: calc((".concat(height, "/2) - 16px);") : "top: calc(50% - 32px);";
}, "  box-shadow:", (0,_utils_boxShadowGenerator__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(), ";/* turning off for now as suggested by design */\n  /* ", CarouselWrapper, ":hover &{visibility:visible;opacity:1;transition:visibility 0s linear 0s,opacity 300ms;}*/\n  ", function(param) {
    var direction = param.direction;
    return direction === "prev" ? "left: 0px;" : "right: -16px;";
}, "  z-index:300;@media (max-width:70.95em){opacity:1;visibility:visible;", function(param) {
    var direction = param.direction;
    return direction === "prev" ? "left: 8px;" : "right: -8px;";
}, "}@media (max-width:47.95em){display:none;}");
var CaraouselInfo = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "ez7effk7",
    label: "CaraouselInfo"
})("display:flex;margin-bottom:", _styles_index__WEBPACK_IMPORTED_MODULE_11__/* .Spacings.SPACING_10B */ .t8.FC, ";align-items:center;padding:0;grid-column:span 18;@media (max-width:70.95em){margin-bottom:24px;}");
var Container = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "ez7effk8",
    label: "Container"
})("width:1136px;margin:auto;@media (max-width:70.95em){width:728px;}@media (max-width:47.95em){width:100%;}");
var Right = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "ez7effk9",
    label: "Right"
})("position:absolute;width:120px;right:0px;height:100%;top:0;z-index:2;background:linear-gradient(\n    270deg,var(--color-base-0) 0%,rgba(252,252,252,0.5) 51.04%,rgba(252,252,252,0) 100%\n  );", function(param) {
    var $hideBackground = param.$hideBackground;
    return $hideBackground ? "background: none;" : null;
}, "  @media (max-width:47.95em){display:none;}");
var ItemWrap = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])("div", {
    target: "ez7effk10",
    label: "ItemWrap"
})("opacity:", function(param) {
    var opacity = param.opacity;
    return opacity;
}, ";display:flex;margin-right:", function(param) {
    var $type = param.$type;
    return $type === "educators" ? "".concat(_styles_index__WEBPACK_IMPORTED_MODULE_11__/* .Spacings.SPACING_6B */ .t8.BY) : 0;
}, ";& .carousel-wrapper-free-platform{width:480px;", _styles_index__WEBPACK_IMPORTED_MODULE_11__/* .mediaQuery.uptoMobile */ .cy.uptoMobile, "{width:320px;}}");
var SeeAll = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_1__["default"])(_base_Button_Button__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
    target: "ez7effk11",
    label: "SeeAll"
})("display:none;@media (max-width:47.95em){display:block;min-height:40px;height:40px;width:calc(100% - 32px);background:var(--color-i-white);border:1px solid var(--color-divider);border-radius:8px;color:var(--color-i-green);font-size:14px;margin:16px 16px 0;}");
var CardCarousel = function(param) {
    var children = param.children, label = param.label, subLabel = param.subLabel, showControls = param.showControls, className = param.className, step = param.step, addPadding = param.addPadding, as = param.as, href = param.href, height = param.height, rightShadowDiv = param.rightShadowDiv, rightShadowDivHeight = param.rightShadowDivHeight, dataAnalytics = param.dataAnalytics, type = param.type, handleSeeAll = param.handleSeeAll, _slideAutomatically = param.slideAutomatically, slideAutomatically = _slideAutomatically === void 0 ? false : _slideAutomatically, extraBenefits = param.extraBenefits, hideBackground = param.hideBackground;
    var isMobile = (0,_hooks_useWindowSize__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)().isMobile;
    var items = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(children);
    var slideInterval = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0), pos = ref[0], setPos = ref[1];
    var handleNext = function() {
        if (items.length - (pos + step) < step) {
            setPos(items.length - step);
        } else setPos(pos + step);
        if (pos === items.length - 1) setPos(0);
    };
    var handlePrev = function() {
        if (pos < step) {
            setPos(0);
        }
        if (pos > 0 && pos >= step) setPos(pos - step);
    };
    var autoSlide = function() {
        if (slideInterval.current) clearTimeout(slideInterval.current);
        slideInterval.current = setTimeout(handleNext, 6000);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (slideAutomatically) {
            autoSlide();
        }
        return function() {
            return clearTimeout(slideInterval.current);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        pos
    ]);
    var controlButtons = function() {
        if (!showControls || items.length <= 1) return;
        var prevAvailable = pos > 0;
        var nextAvailable = pos + step < items.length;
        // const nextAvailable = pos < items.length - numberOfItems;
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .Fragment */ .HY, {
            children: [
                prevAvailable && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ControlButton, {
                    onClick: handlePrev,
                    direction: "prev",
                    height: height,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_icon_ChevronLeft__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        size: "24px",
                        "aria-hidden": "true"
                    })
                }),
                nextAvailable && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ControlButton, {
                    onClick: handleNext,
                    direction: "next",
                    height: height,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_icon_ChevronRight__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        size: "24px",
                        "aria-hidden": "true"
                    })
                })
            ]
        });
    };
    var finalItems = items.map(function(item, index) {
        var gridColumnForItem = item.props.gridColumn;
        var opacity = index < pos ? 0 : 1;
        var _uid;
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(ItemWrap, {
            gridColumn: gridColumnForItem,
            opacity: opacity,
            $type: type,
            children: item
        }, (_uid = item.uid) !== null && _uid !== void 0 ? _uid : item.key);
    });
    var seeAllAnalytics = function() {
        handleSeeAll();
    };
    var pauseCarousel = function() {
        if (!slideAutomatically) return;
        clearTimeout(slideInterval.current);
    };
    var handleSeeAllClick = function() {
        if (href && as) (0,_utils_pushRoute__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(href, as);
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(Container, {
        className: "carousel-container",
        onMouseOver: pauseCarousel,
        onMouseLeave: autoSlide,
        children: [
            label ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(CaraouselInfo, {
                className: className,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(Column, {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(StyH3, {
                                children: label
                            }),
                            subLabel && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(SubLabel, {
                                children: subLabel
                            }),
                            extraBenefits
                        ]
                    }),
                    isMobile ? null : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_base_Grow_Grow__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {}),
                    as && !isMobile ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(_comp_UnderlineLink_UnderlineLink__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        as: as,
                        href: href,
                        color: "var(--color-i-green)",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(GreenH4, {
                            "data-analytics": "subscription-".concat(dataAnalytics, "-seeAll"),
                            onClick: seeAllAnalytics,
                            children: "See all"
                        })
                    }) : null
                ]
            }) : null,
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(CarouselWrapper, {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)("div", {
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsxs */ .BX)(CardContainer, {
                            className: "card-carosel-container",
                            addPadding: addPadding,
                            pos: pos,
                            children: [
                                finalItems,
                                controlButtons()
                            ]
                        })
                    }),
                    rightShadowDiv && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(Right, {
                        $height: rightShadowDivHeight,
                        $hideBackground: hideBackground
                    })
                ]
            }),
            type === "dummy" ? null : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_15__/* .jsx */ .tZ)(SeeAll, {
                label: "See All",
                onClick: handleSeeAllClick
            })
        ]
    });
};
CardCarousel.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().node.isRequired),
    label: prop_types__WEBPACK_IMPORTED_MODULE_16___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_16___default().object)
    ]),
    subLabel: prop_types__WEBPACK_IMPORTED_MODULE_16___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_16___default().object)
    ]),
    showControls: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().bool),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string),
    step: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().number),
    addPadding: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().bool),
    as: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string),
    href: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string),
    height: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string),
    rightShadowDiv: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().bool),
    rightShadowDivHeight: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string),
    dataAnalytics: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string),
    type: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string.isRequired),
    handleSeeAll: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().func),
    extraBenefits: prop_types__WEBPACK_IMPORTED_MODULE_16___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_16___default().string),
        (prop_types__WEBPACK_IMPORTED_MODULE_16___default().node)
    ]),
    hideBackground: (prop_types__WEBPACK_IMPORTED_MODULE_16___default().bool)
};
CardCarousel.defaultProps = {
    label: null,
    subLabel: null,
    showControls: true,
    className: "",
    step: 2,
    addPadding: false,
    as: null,
    href: null,
    height: null,
    rightShadowDiv: true,
    rightShadowDivHeight: "320px",
    dataAnalytics: "",
    handleSeeAll: function() {
        return null;
    },
    extraBenefits: null,
    hideBackground: false
};
/* harmony default export */ __webpack_exports__["Z"] = (CardCarousel);


/***/ }),

/***/ 26845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55447);







var StyledIcon = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "e1j6dsxd0",
    label: "StyledIcon"
})("fill:none;");
var CalendarSleek = function(props) {
    var color = props.color, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "color"
    ]);
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledIcon, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 20 21"
    }, rest), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M5.833 3.208c.345 0 .625.28.625.625v1.39c2.357-.21 4.727-.21 7.084 0v-1.39a.625.625 0 0 1 1.25 0v1.514a2.813 2.813 0 0 1 2.393 2.416l.072.544a24.16 24.16 0 0 1-.078 6.89 2.508 2.508 0 0 1-2.231 2.11l-.995.098c-2.629.26-5.277.26-7.906 0l-.995-.098a2.508 2.508 0 0 1-2.232-2.11 24.162 24.162 0 0 1-.077-6.89l.072-.544a2.813 2.813 0 0 1 2.393-2.416V3.833c0-.345.28-.625.625-.625zm.371 3.295a38.676 38.676 0 0 1 7.592 0l.754.074c.722.071 1.3.63 1.396 1.35l.072.544c.025.19.048.38.069.57H3.913c.02-.19.044-.38.069-.57l.072-.544a1.563 1.563 0 0 1 1.396-1.35l.754-.074zm-2.39 3.789a22.912 22.912 0 0 0 .242 4.713 1.258 1.258 0 0 0 1.12 1.058l.993.098c2.548.251 5.114.251 7.662 0l.994-.098a1.258 1.258 0 0 0 1.12-1.058c.242-1.56.323-3.14.24-4.713H3.815z",
            fill: color
        })
    })));
};
CalendarSleek.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};
CalendarSleek.defaultProps = {
    color: "var(--color-text-primary)"
};
/* harmony default export */ __webpack_exports__["Z"] = (CalendarSleek);


/***/ }),

/***/ 19927:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var ChevronLeft = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M52.033 20.2c0 0.003 0 0.008 0 0.012 0 0.687-0.28 1.308-0.733 1.755l-18.234 18.234 18.233 18.233c0.49 0.458 0.796 1.108 0.796 1.829 0 1.381-1.119 2.5-2.5 2.5-0.721 0-1.371-0.306-1.828-0.794l-0.001-0.001-20-20c-0.452-0.452-0.731-1.077-0.731-1.767s0.279-1.314 0.731-1.767v0l20-20c0.452-0.452 1.077-0.731 1.767-0.731s1.314 0.279 1.767 0.731v0c0.453 0.447 0.733 1.068 0.733 1.755 0 0.004 0 0.008 0 0.012v-0.001z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (ChevronLeft);


/***/ }),

/***/ 57586:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95934);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55447);







var StyledIcon = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__["default"])(_Icon__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    target: "efk165f0",
    label: "StyledIcon"
})("fill:none;");
var EducatorAvatar = function(props) {
    var color = props.color, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(props, [
        "color"
    ]);
    return(// eslint-disable-next-line react/jsx-props-no-spreading
    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(StyledIcon, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        viewBox: "0 0 20 20"
    }, rest), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M6.458 6.25a3.542 3.542 0 1 1 7.084 0 3.542 3.542 0 0 1-7.084 0zM10 3.958a2.292 2.292 0 1 0 0 4.584 2.292 2.292 0 0 0 0-4.583zM6.667 12.292c-1.036 0-1.875.84-1.875 1.875v.99c0 .015.01.028.025.03 3.433.56 6.933.56 10.365 0a.03.03 0 0 0 .026-.03v-.99c0-1.036-.84-1.875-1.875-1.875h-.284a.208.208 0 0 0-.064.01l-.722.236a7.29 7.29 0 0 1-4.526 0l-.722-.236a.209.209 0 0 0-.064-.01h-.284zm-3.125 1.875c0-1.726 1.399-3.125 3.125-3.125h.284c.153 0 .306.024.452.072l.722.235a6.042 6.042 0 0 0 3.75 0l.722-.235c.146-.048.299-.072.452-.072h.284c1.726 0 3.125 1.399 3.125 3.125v.99a1.28 1.28 0 0 1-1.074 1.264 33.416 33.416 0 0 1-10.768 0 1.28 1.28 0 0 1-1.074-1.264v-.99z",
            fill: color
        })
    })));
};
EducatorAvatar.propTypes = {
    color: (prop_types__WEBPACK_IMPORTED_MODULE_6___default().string)
};
EducatorAvatar.defaultProps = {
    color: "var(--color-text-primary)"
};
/* harmony default export */ __webpack_exports__["Z"] = (EducatorAvatar);


/***/ }),

/***/ 21589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35944);
/* harmony import */ var _Icon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55447);




var Lock = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Icon__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        path: "M61.667 27.233h-5.567v-3.333c0-8.892-7.208-16.1-16.1-16.1s-16.1 7.208-16.1 16.1v0 3.333h-5.567c-1.373 0.019-2.481 1.127-2.5 2.498v36.668c0 1.381 1.119 2.5 2.5 2.5v0h43.333c1.381 0 2.5-1.119 2.5-2.5v0-36.667c-0.019-1.373-1.127-2.481-2.498-2.5h-0.002zM28.9 23.9c0-6.13 4.97-11.1 11.1-11.1s11.1 4.97 11.1 11.1v0 3.333h-22.2zM40 54.7c-3.222 0-5.833-2.612-5.833-5.833s2.612-5.833 5.833-5.833c3.222 0 5.833 2.612 5.833 5.833v0c0 3.222-2.612 5.833-5.833 5.833v0z"
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Lock);


/***/ }),

/***/ 11238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ SKIP_REASONS_MAP; }
/* harmony export */ });
/* eslint-disable import/prefer-default-export */ var SKIP_REASONS_MAP = {
    DIFFICULT_QUESTION: "Difficult Question",
    DIDNT_UNDERSTAND: "Didn't Understand",
    HAVENT_STUDIED: "Haven't studied"
};


/***/ }),

/***/ 11680:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "GA": function() { return /* binding */ getUserById; },
/* harmony export */   "jo": function() { return /* binding */ getMe; }
/* harmony export */ });
/* unused harmony exports getProfileInfo, getProfileStats, getLearnerMilestones, getLearnerAchievedMileStones, getCompletedCourses, getFeedRowById, getProfileFeed, getFollowingList, getCourseById, getBatchById, getItemById, getTopologyById, isFollowingEducator */
/* harmony import */ var _constants_empty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59375);

var getMe = function(param) {
    var auth = param.auth;
    return auth.me;
};
var getProfileInfo = function(username) {
    return function(param) {
        var users = param.users;
        return users.data[username];
    };
};
var getProfileStats = function(username) {
    return function(param) {
        var users = param.users;
        return users.profileStats[username] || {};
    };
};
var getLearnerMilestones = function(state, username) {
    return state.users.learnerMilestones[username] || emptyObject;
};
var getLearnerAchievedMileStones = function(state, username) {
    return getLearnerMilestones(state, username).achieved || emptyList;
};
var getCompletedCourses = function(username) {
    return function(param) {
        var paginator = param.paginator;
        return paginator.learnerCourses[username];
    };
};
var getFeedRowById = function(feedrowId) {
    return function(param) {
        var feedrows = param.feedrows;
        return feedrows.data[feedrowId];
    };
};
var _username;
var getProfileFeed = function(username) {
    return function(param) {
        var paginator = param.paginator;
        return (_username = paginator.profileFeed[username]) !== null && _username !== void 0 ? _username : {};
    };
};
var getFollowingList = function(username) {
    return function(param) {
        var paginator = param.paginator;
        return paginator.learnerFollowing[username];
    };
};
var getCourseById = function(courseUID) {
    return function(param) {
        var courses = param.courses;
        return courses.data[courseUID];
    };
};
var getBatchById = function(batchUID) {
    return function(param) {
        var batches = param.batches;
        return batches.data[batchUID];
    };
};
var getUserById = function(username) {
    return function(param) {
        var users = param.users;
        return users.data[username];
    };
};
var getItemById = function(itemUID) {
    return function(param) {
        var items = param.items;
        return items.data[itemUID];
    };
};
var getTopologyById = function(topologyUID) {
    return function(param) {
        var topologies = param.topologies;
        return topologies.data[topologyUID];
    };
};
var isFollowingEducator = function(username) {
    return function(param) {
        var users = param.users;
        var ref;
        return (ref = users.data[username.toLowerCase()]) === null || ref === void 0 ? void 0 : ref.isFollowing;
    };
};


/***/ })

}]);